import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DataFieldsService } from '../../services/data-fields.service';
import { DatePipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { StorageService } from 'src/app/services/storage.service';
import { async } from '@angular/core/testing';
import { ConnectionService } from 'src/app/services/connection.service';
import { ToastService } from '../../services/toast.service';
import { LoaderService } from 'src/app/services/loader.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-icic-proposal-form',
  templateUrl: './icic-proposal-form.page.html',
  styleUrls: ['./icic-proposal-form.page.scss'],
})
export class ICICProposalFormPage implements OnInit {
  salarycondtn: boolean;
  userObj: any;
  showErrorDiv: any;
  errdecptn: any;
  applicationOrderId: any;
  upgradedQuoteResponseObj: any;
  appResData: any;
  hidebackbtn: boolean = true;
  ShowHeaderRow: boolean = true;
  proposerDetailsForm: FormGroup;
  LifeDetailsForm: FormGroup;
  MwpaDetailsForm: FormGroup;
  HealthDetailsForm: FormGroup;
  UploadDocumentsDetailsForm: FormGroup;
  paymentDocumentsForm: FormGroup;
  firstslide: boolean;
  proposal_data: any;
  lifeassured_data: any;
  paymentDocument_data: any;
  nomineandinsdata: any;
  uploaddocument_data_kyc_proposer: any;
  health_data: any;
  lf_nm_dob: any;
  dobMax: any;
  dependflagResponse: any;
  uploaddoc_data_kyc_lifeassured: any;
  uploaddoc_pannumber: any;
  uploadoc_aharnumber: any;
  upload_photosubmitted: any;
  main_Object: any;
  enablepayment: boolean;

  genderlist: any = [];
  maritalstatuslist: any = [];
  remarkarry = [];
  educationlist: any = [];
  occupationlist: any = [];
  myprofessionlist: any = [];
  organisationotherslist: any = [];
  industrytypelist: any = [];
  organsiationselfemployed: any = [];
  sourceofincome: any = [];
  objectivepolicy: any = [];
  statelist: any = []
  countrylist: any = [];
  insurancecompanylist: any = [];
  relationshiptopropser: any = [];
  nationalitylist: any = [];
  residentallist: any = [];
  trusteelist: any = [];
  tobacoconsumed: any = [];
  tobaccoqtylist: any = [];
  alcoholconsumedas: any = [];
  alcoholqtylist: any = [];
  idproof: any = [];
  ageproof: any = [];
  addressproof: any = [];
  incomeproof: any = [];
  itproof: any = [];
  nameoforganisation: any = [];
  relationoflatoPR: any = [];
  eiadetailsList: any = [];
  accounttypelist: any = [];
  modeofdepositelist: any = [];
  modeofpayFrequency: any = [];
  nomineerelationship: any = [];
  relationofMWPAbeneficiarytoPR: any = [];
  residentallistnonindian: any = [];
  salutationlist: any = [];

  //boolean values
  firstslidenext: boolean;
  showspouse: boolean;
  showhealthdeclatnform: boolean;
  showspouse_lf: boolean;
  showDeclartionques: boolean;
  showIndustypeQues: boolean;
  showOccDesc: boolean;
  showOccDesc_lf: boolean;
  showProfession: boolean;
  showProfession_lf: boolean;
  showselfemplyoed: boolean;
  showselfemplyoed_lf: boolean;
  showindustry: boolean;
  showorgdesc: boolean;
  showorgdesc_lf: boolean;
  showOcctypeOC: boolean;
  showOcctypeOC_lf: boolean;
  showindesc: boolean;
  showprsourceOfFundDesc: boolean;
  showprobjective: boolean;
  showinsurancedetails: boolean;
  shownomineedetials: boolean = true;
  showbeneficerydetails: boolean;
  showappontieedeatils: boolean;
  trusteedetails: boolean;
  hlslecetdescrptn: boolean;
  showproposerresidential: boolean;
  showNRIProposer: boolean;
  showpr_NRItraveldetails: boolean;
  showProposerForm: boolean;
  showLifeassuredForm: boolean;
  showHealthDeatilsForm: boolean;
  showUploadDetailsForm: boolean;
  showProposerForm1: boolean = true;
  showpaymentDocumentForm: boolean;
  showNomineeandIns: boolean;
  communicationDetails: boolean;
  showTobacooConsumedas: boolean;
  showalcoholas: boolean;
  showchemicalexposure: boolean;
  showarmydescp: boolean;
  sholostwgtsdescp: boolean;
  showillnesdescp: boolean;
  showsurgerydescp: boolean;
  showmedsuffering: boolean;
  showmedhandicap: boolean;
  showmedinjury: boolean;
  showpregntweeks: boolean;
  showresidential: boolean;
  showNRI: boolean;
  showNRItraveldetails: boolean;
  showpan: boolean;
  showEIAaccnumber: boolean;
  showLifeassuredformbtn: boolean;
  showNameoforgn: boolean;
  showNameoforgn_lf: boolean;
  showpropres_nonindian: boolean;
  showres_nonindian: boolean;
  showSubmitAPIdiv: boolean;
  showmwpaquestion: boolean;
  showAddrSameProposer: boolean;
  showCongratulations: boolean;
  dateOfBirth: any;
  disablepr_DOB: boolean = false;
  disablelf_DOB: boolean = false;
  disableFormSegmentBtns: boolean = true;
  pregnentques: boolean;

  monthlySI: boolean = false;

  quoteFormResObj: any;
  product_selected: any;

  //name of org va
  naoforganstn: any = [];
  variablevalue: any;
  keyword = "organizationName";
  shownameoforgansdecrptn: any;
  shownameoforgansdecrptn_lf: any;

  proposerFilled: any = "section-btn active-section-btn";
  lifeAssuredFilled: any = "section-btn";
  healthDetailsFilled: any = "section-btn";
  uploadDocumentsFilled: any = "section-btn";
  EIADetailsfilled: any = "section-btn";
  policyHolderFullName: string = "";
  showCovidQue30SubReflex: boolean;
  showCovidQue33SubReflex: boolean;
  showCovidQue38Sub: boolean;
  showCovidQue43Sub: boolean;
  showCovidQue56Sub: boolean;

  payoutTerm: Number;

  // ecsDetails: any;
  // ecsOpted: boolean = false;
  // ecsMandatory: boolean = false;

  constructor(private fb: FormBuilder,
    private _dataFields: DataFieldsService,
    private _datePipe: DatePipe,
    private titlecasePipe: TitleCasePipe,
    private uppercasePipe: UpperCasePipe,
    private strg: StorageService,
    private apiService: ConnectionService,
    private toast: ToastService,
    private loader: LoaderService,
    private router: Router,
    private alertCtrl: AlertController
  ) {
    // this.strg.getStoreData("quoteFormData").then(res => {
    //   this.quoteFormResObj = res;
    //   if(this.quoteFormResObj.qt_gender === "Male"){
    //     this.pregnentques = false;
    //   }else {
    //     this.pregnentques = true;
    //   }
    // });
    // // this.strg.getStoreData("dependflagResponse-data").then(res =>{
    // //   this.dependflagResponse = res;
    // // })
    // this.strg.getStoreData("userObj").then(res => {
    //   this.userObj = res;
    //   this.prPhoneNumber = this.userObj.phoneNumber;
    //   this.strg.getStoreData("incp").then(ress => {
    //     console.log("mmmmm", ress)
    //     if (ress === true) {
    //       console.log("incomplete");
    //       this.getIncompleteApplication();
    //     } else {
    //       console.log("complete");
    //       this.getAppOrderId();
    //     }
    //   })
    // })

    // //ecs details
    // this.strg.getStoreData("ecsDetails").then(res => {
    //   console.log("resssss*************ecs", res);
    //   if(res){
    //     this.ecsDetails = res;
    //     this.ecsOpted = true;
    //   } else{
    //     this.ecsOpted = false;
    //   }
    // })

    // this.strg.getStoreData("ecsMandatory").then(res => {
    //   if(res){
    //     this.ecsMandatory = true;
    //   } else{
    //     this.ecsMandatory = false;
    //   }
    // })

    // this.strg.getStoreData("isEcsOkay").then(res => {
    //   console.log("**************** ecs okay ******************", res)
    //   if(res){
    //     this.isEcsOkay = true;
    //     // this.subAppAfterEcs();
    //     // let currentUrl = this.router.url;
    //     // this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
    //     //     this.router.navigate([currentUrl]);
    //     // });
    //   }
    // });

  }

  isEcsOkay: boolean = false;

  ionViewDidEnter() {
    this.strg.getStoreData("quoteFormData").then(res => {
      this.quoteFormResObj = res;
      if (this.quoteFormResObj.qt_gender === "Male") {
        this.pregnentques = false;
      } else {
        this.pregnentques = true;
      }
    });
    // this.strg.getStoreData("dependflagResponse-data").then(res =>{
    //   this.dependflagResponse = res;
    // })
    this.strg.getStoreData("userObj").then(res => {
      this.userObj = res;
      this.prPhoneNumber = this.userObj.phoneNumber;
      this.strg.getStoreData("incp").then(ress => {
        console.log("mmmmm", ress)
        if (ress === true) {
          console.log("incomplete");
          this.getIncompleteApplication();
        } else {
          console.log("complete");
          this.getAppOrderId();
        }
      })
    })

    //ecs details
    // this.strg.getStoreData("ecsDetails").then(res => {
    //   console.log("resssss*************ecs", res);
    //   if(res){
    //     this.ecsDetails = res;
    //     this.ecsOpted = true;
    //   } else{
    //     this.ecsOpted = false;
    //   }
    // })

    // this.strg.getStoreData("ecsMandatory").then(res => {
    //   if(res){
    //     this.ecsMandatory = true;
    //   } else{
    //     this.ecsMandatory = false;
    //   }
    // })

    // this.strg.getStoreData("isEcsOkay").then(res => {
    //   console.log("**************** ecs okay ******************", res)
    //   if(res){
    //     this.isEcsOkay = true;
    //     // this.subAppAfterEcs();
    //     // let currentUrl = this.router.url;
    //     // this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
    //     //     this.router.navigate([currentUrl]);
    //     // });
    //   }
    // });
  }

  get insArray() {
    return this.proposerDetailsForm.get('insuranceArray') as FormArray;
  }

  addPreIns() {
    this.insArray.push(this.fb.group({
      cmpany: ['', [Validators.required]],
      sum: ['', [Validators.required]]
    }));
  }

  removePreIns(index) {
    this.insArray.removeAt(index);
  }

  get benefiArray() {
    return this.MwpaDetailsForm.get('beneficiaryArray') as FormArray;
  }

  addBeneficiary() {
    if (this.maxShareAllowed > 0) {
      if (this.benefiArray.valid) {
        if (this.benefiArray.length < 6) {
          this.benefiArray.push(this.fb.group({
            frstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
            lstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
            relationship: ['', Validators.required],
            dob: ['', Validators.required],
            shareOfBenefit: [this.maxShareAllowed, [Validators.required, Validators.max(this.maxShareAllowed)]],
            isMinor: [''],
          }));
        } else {
          this.toast.showToast("Beneficiary Limit exceeds");
          // this.benefiArray.at(index).get('shareOfBenefit').setValue(this.maxShareAllowed);
        }
      } else {
        this.toast.showToast("Fill the beneficiary details to add another");
      }
    } else {
      this.toast.showToast("Beneficiary Share is Already 100%");
    }
  }

  removeBeneficiary(index) {
    this.benefiArray.removeAt(index);
    let benefShare = 0;
    this.benefiArray.controls.forEach(res => {
      benefShare = Number(benefShare) + Number(res.value.shareOfBenefit);
    })
    if (benefShare < 100 || benefShare > 100)
      this.benefiArray.at(index - 1).get('shareOfBenefit').setErrors({ invalid: true });
  }

  maxShareAllowed: any = 100;

  // checkBeneficiaryPercentage(event, index) {
  //   let sharePercentage = 0;
  //   this.maxShareAllowed = 100;
  //   let formcontrols = this.benefiArray.controls;
  //   let benefShare = 0;
  //   formcontrols.forEach(res => {
  //     benefShare = Number(benefShare) + Number(res.value.shareOfBenefit);
  //   })

  //   this.benefiArray.value.forEach(res => {
  //     sharePercentage = Number(sharePercentage) + Number(res.shareOfBenefit);
  //   });
  //   this.maxShareAllowed = this.maxShareAllowed - sharePercentage;

  //   if (event.detail.value < 100 && event.detail.value != "") {
  //     // if(this.benefiArray.length < 6 && this.benefiArray.valid && sharePercentage < 100){
  //     if (this.benefiArray.length < 6 && this.maxShareAllowed > 0 && sharePercentage < 100) {
  //       // console.log("make another one");
  //       this.addBeneficiary();
  //     } else {
  //       // console.log("not valid!!!!")
  //       // console.log('maxxxxxxx',this.maxShareAllowed,'shaaaarrre', sharePercentage)
  //       if (benefShare < 100 || benefShare > 100) {
  //         alert("overall beneficiary share should be exact 100%");
  //         // this.benefiArray.at(index).get('shareOfBenefit').setValue(this.maxShareAllowed);
  //       }
  //     }
  //   } else {
  //     // console.log("not vvvvvalid!!!!")
  //     // console.log('maxxxxxxx',this.maxShareAllowed,'shaaaarrre', sharePercentage)
  //     if (benefShare < 100 || benefShare > 100) {
  //       alert("overall beneficiary share should be exact 100%");
  //     } else {
  //       if (this.benefiArray.length != 1)
  //         this.removeBeneficiary(index);
  //     }
  //   }

  // }

  checkBeneficiaryPercentage(event, index) {
    let sharePercentage = 100;
    let ccc = 0;
    this.benefiArray.controls.forEach(f => {
      ccc += Number(f.get('shareOfBenefit').value);
    });
    sharePercentage = Number(sharePercentage) - Number(ccc);
    this.maxShareAllowed = sharePercentage;
  }

  monthlyFreq: boolean = false;
  sameAsChecked: boolean = false;
  appIncompleteData: any;
  getIncompleteApplication() {
    this.loader.showLoader();
    // this.apiService.getIncompleteICICIAppData(this.userObj.id).subscribe(res => { //for direct ref
    this.apiService.getIncompleteICICIAppData().subscribe(res => {
      this.loader.hideLoader();
      if (res) {
        if (res.data.length != 0) {
          console.log("appINcompe", res);
          // let data = res.data.reverse();
          let data = res.data;
          data = data[0];
          this.upgradedQuoteResponseObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam);
          if (this.upgradedQuoteResponseObj.modeOfPayment === "Monthly") {
            this.monthlyFreq = true;
          } else {
            this.monthlyFreq = false;
          }
          this.applicationOrderId = data.insuranceOrderHistory.id;
          this.appIncompleteData = JSON.parse(data.parameter);
          console.log("incomplete data details", this.appIncompleteData);
          this.validateSelfProposed();
          this.autoFillFormData(this.appIncompleteData);
        } else {
          this.getAppOrderId();
        }
      }
    }, err => {
      this.loader.hideLoader();
      console.log("error", err);
    });
  }

  saveIncompleteAppData(data) {
    let dataIncomplete = {
      "orderId": this.applicationOrderId,
      "applicationData": data
    }

    this.apiService.saveIncompleteICICIAppData(dataIncomplete).subscribe(res => {
      console.log("save incomplete app data res", res);
    }, err => {
      console.log("save incomplete error", err)
    });
  }

  autoFillFormData(autoFillData) {
    if (autoFillData.dependflagResponse) {
      let autoFillDependantInfo = autoFillData.dependflagResponse;
      // this.proposerDetailsForm.get('pr_selfProposed').setValue(autoFillDependantInfo.dependentFlag)
      this.proposerDetailsForm.get('pr_selfProposed').setValue("N")
      this.proposerDetailsForm.get('pr_relWithLA').setValue(autoFillDependantInfo.relationWithLa)
      this.validateSelfProposed();
    }
    if (autoFillData.proposerDetails) {
      let autoFillProposer = autoFillData.proposerDetails;
      this.proposerDetailsForm.setValue(autoFillProposer);
      console.log("****proposer auto fill****", autoFillProposer);
      this.proposerOtherFieldsValidation();
      if (this.proposerDetailsForm.get('pr_gender').value === 'Male' && this.proposerDetailsForm.get('pr_mrtlSts').value === '696') {
        this.showmwpaquestion = true;
      }
      else {
        this.showmwpaquestion = false;
        this.MwpaDetailsForm.get('lf_mwpaOpted').setValue(false);
        // this.NomineandINSshowField();
      }
      if (autoFillProposer.pr_line1 === autoFillProposer.pr_currnt_line1 && autoFillProposer.pr_line2 === autoFillProposer.pr_currnt_line2
        && autoFillProposer.pr_line3 === autoFillProposer.pr_currnt_line3 && autoFillProposer.pr_landmark === autoFillProposer.pr_currnt_landmark
        && autoFillProposer.pr_city === autoFillProposer.pr_currnt_city && autoFillProposer.pr_pincode === autoFillProposer.pr_currnt_pincode
        && autoFillProposer.pr_state === autoFillProposer.pr_current_state && autoFillProposer.pr_country === autoFillProposer.pr_current_country) {
        this.sameAsChecked = true;
      } else {
        this.sameAsChecked = false;
      }
      this.occupationValidate();
      // if(autoFillProposer.pr_nameOfOrg == "Others"){
      console.log("asdadsadad", autoFillProposer.pr_nameOfOrg, autoFillData.pr_nameOfOrgdecstn);
      // this.nameoforganisationtogle(autoFillProposer.pr_nameOfOrg);
      // }
      // if(this.proposerDetailsForm.get('pr_nameOfOrg').value.organizationName === "Others"){
      //   console.log("fffff")
      // if(autoFillProposer.pr_nameOfOrg == "Others"){
      // }
    }
    if (autoFillData.lifeAssuredDetails) {
      // this.showLifeassuredForm = true;
      // this.showProposerForm1 = false;
      // this.showNomineeandIns = false;
      // this.showHealthDeatilsForm = false;
      // this.showUploadDetailsForm = false;
      // this.showpaymentDocumentForm = false;
      // this.showSubmitAPIdiv = false;
      // this.showCongratulations = false;
      // this.showErrorDiv = false;
      // this.proposerFilled = "section-btn section-done-btn";
      // this.lifeAssuredFilled = "section-btn active-section-btn";
      // this.healthDetailsFilled = "section-btn";
      // this.uploadDocumentsFilled = "section-btn";
      let autoFillLifeInfo = autoFillData.lifeAssuredDetails
      this.LifeDetailsForm.setValue(autoFillLifeInfo);
    }
    if (autoFillData.nomineeDetails) {
      // this.showNomineeandIns = true;
      // this.showLifeassuredForm = false;
      // this.showHealthDeatilsForm = false;
      // this.showUploadDetailsForm = false;
      // this.showpaymentDocumentForm = false;
      // this.showProposerForm1 = false;
      // this.showSubmitAPIdiv = false;
      // this.showCongratulations = false;
      // this.showErrorDiv = false;
      // this.proposerFilled = "section-btn active-section-btn";
      // this.lifeAssuredFilled = "section-btn";
      // this.healthDetailsFilled = "section-btn";
      // this.uploadDocumentsFilled = "section-btn";
      let autoFillNominee = autoFillData.nomineeDetails;
      if (autoFillNominee.beneficiaryArray) {
        for (let i = 1; i < autoFillNominee.beneficiaryArray.length; i++) {
          this.addBeneficiary();
        }
      }
      this.MwpaDetailsForm.setValue(autoFillNominee);
      this.NomineandINSshowField();
    }
    if (autoFillData.healthDetails) {
      // this.showHealthDeatilsForm = true;
      // this.showLifeassuredForm = false;
      // this.showNomineeandIns = false;
      // this.showUploadDetailsForm = false;
      // this.showpaymentDocumentForm = false;
      // this.showProposerForm1 = false;
      // this.showSubmitAPIdiv = false;
      // this.showCongratulations = false;
      // this.showErrorDiv = false;
      // this.proposerFilled = "section-btn section-done-btn";
      // this.lifeAssuredFilled = "section-btn section-done-btn";
      // this.healthDetailsFilled = "section-btn active-section-btn";
      // this.uploadDocumentsFilled = "section-btn";
      console.log("hhhhhhh", autoFillData.healthDetails);
      this.HealthDetailsForm.setValue(autoFillData.healthDetails);
    }
    if (autoFillData.uploadDetials) {
      // this.showUploadDetailsForm = true;
      // this.showpaymentDocumentForm = false;
      // this.showHealthDeatilsForm = false;
      // this.showLifeassuredForm = false;
      // this.showNomineeandIns = false;
      // this.showSubmitAPIdiv = false;
      // this.showCongratulations = false;
      // this.showErrorDiv = false;
      // this.proposerFilled = "section-btn section-done-btn";
      // this.lifeAssuredFilled = "section-btn section-done-btn";
      // this.healthDetailsFilled = "section-btn section-done-btn";
      // this.uploadDocumentsFilled = "section-btn active-section-btn";
      let autoFillUploadDocs = autoFillData.uploadDetials
      console.log("***upload auto fill***", autoFillUploadDocs)
      this.UploadDocumentsDetailsForm.setValue(autoFillUploadDocs);
      this.uploadDocument();
    }
    if (autoFillData.paymentDetails) {
      // this.showUploadDetailsForm = true;
      // this.showpaymentDocumentForm = false;
      // this.showHealthDeatilsForm = false;
      // this.showLifeassuredForm = false;
      // this.showNomineeandIns = false;
      // this.showSubmitAPIdiv = false;
      // this.showCongratulations = false;
      // this.showErrorDiv = false;
      // this.proposerFilled = "section-btn section-done-btn";
      // this.lifeAssuredFilled = "section-btn section-done-btn";
      // this.healthDetailsFilled = "section-btn section-done-btn";
      // this.uploadDocumentsFilled = "section-btn active-section-btn";
      let autoFillPaymentData = autoFillData.paymentDetails
      this.paymentDocumentsForm.setValue(autoFillPaymentData);
    }

    // if(this.isEcsOkay){
    //   setTimeout(()=>{
    //     this.subAppAfterEcs();
    //   },1500)
    // }
  }

  getAppOrderId() {
    this.loader.showLoader();
    let dataa = {
      "productName": "ICICI Pru iProtect Smart",
      "latest": true
    }
    this.apiService.getQuotesByUserId(dataa).subscribe(res => {
      this.loader.hideLoader();
      console.log("get quote res", res);
      // let quoteRes = res.data.filter(item => item.insuranceQuoteRequest.insuranceProductDetails.name === "ICICI Pru iProtect Smart");
      console.log("*************", res.data);
      let latestId = res.data.pop();
      // let data = {
      //   "quoteResponseId": quoteRes[0].id
      // }
      let data = {
        "quoteResponseId": latestId.id
      }
      this.payoutTerm = JSON.parse(latestId.insuranceQuoteRequest.reqParam).payoutTerm
      console.log("get quote res", data, this.payoutTerm);
      // this.upgradedQuoteResponseObj = JSON.parse(quoteRes[0].responseParam);
      this.upgradedQuoteResponseObj = JSON.parse(latestId.responseParam);
      if (this.upgradedQuoteResponseObj.modeOfPayment === "Monthly") {
        this.monthlyFreq = true;
      } else {
        this.monthlyFreq = false;
      }
      this.validateSelfProposed();
      this.apiService.getApplicationOrderId(data).subscribe(res => {
        this.applicationOrderId = res.data.id;
      })
    })
  }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.strg.getStoreData("monthlySI").then(res => {
      console.log("monthlySI", res)
      if (res === true) {
        this.monthlySI = true;
      } else {
        this.monthlySI = false;
      }
    })

    this.dobMax = new Date(Date.now());

    this.proposerDetailsForm = this.fb.group({
      pr_selfProposed: [''],
      pr_relWithLA: [''],
      pr_frstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
      pr_lstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
      pr_gender: [{ disabled: this.disablepr_DOB, value: '' }, Validators.required],
      pr_dob: [{ disabled: this.disablepr_DOB, value: '' }, Validators.required],
      pr_email: ['', Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')],
      pr_mrtlSts: ['', Validators.required],
      pr_spouseName: ['', [Validators.minLength(1), Validators.maxLength(30)]],
      pr_fatherName: ['', [Validators.minLength(1), Validators.maxLength(30)]],
      pr_motherName: ['', [Validators.minLength(1), Validators.maxLength(30)]],
      pr_education: ['', Validators.required],
      pr_occ: ['', Validators.required],
      pr_myprof: [''],
      pr_occDesc: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_orgType: [''],
      pr_indsType: [''],
      pr_org_selfemployed: [''],
      pr_orgTypeDesc: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_nameOfOrg: [''],
      pr_nameOfOrgdecstn: [''],
      pr_annlncme: ['', [Validators.required, Validators.min(2), Validators.max(10000000000)]],
      pr_pltclyExpsd: [false, Validators.required],
      pr_sharePortfolio: [true, Validators.required],
      pr_indsTypeQuestion: [],
      pr_currentlyInvestigated: [false],
      pr_investigationDtls: [''],
      pr_sourceOfFund: ['', Validators.required],
      pr_sourceOfFundDesc: ['', [Validators.minLength(0), Validators.maxLength(30)]],
      pr_objective: ['', [Validators.required]],
      pr_objective_others: ['', [Validators.minLength(0), Validators.maxLength(30)]],
      pr_line1: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      pr_line2: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_line3: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_landmark: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_city: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      pr_pincode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      pr_state: ['', Validators.required],
      pr_country: ['', Validators.required],
      pr_currnt_line1: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      pr_currnt_line2: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_currnt_line3: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_currnt_landmark: ['', [Validators.minLength(2), Validators.maxLength(30)]],
      pr_currnt_city: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      pr_currnt_pincode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      pr_current_state: ['', Validators.required],
      pr_current_country: ['', Validators.required],
      pr_nationality: ['', Validators.required],
      pr_rstSts: [''],
      pr_rstSts_NIndian: [''],
      pr_rstSts_nri: [''],
      pr_rstSts_nri_country: [''],
      pr_rstSts_nri_nationlity: [''],
      pr_rstSts_tin1_contry: [''],
      pr_rstSts_tin1_pan1: ['', Validators.pattern("[A-Za-z]{5}\d{4}[A-Za-z]{1}")],
      pr_rstSts_tin2_contry: [''],
      pr_rstSts_tin2_pan2: ['', Validators.pattern("[A-Za-z]{5}\d{4}[A-Za-z]{1}")],
      pr_rstSts_passport: [''],
      pr_rstSts_DOA: [''],
      pr_rstSts_DOL: [''],
      pr_rstSts_DOS: [''],
      pr_rstSts_DOSM: [''],
      pr_rstSts_purpse: [''],
      pr_rstSts_emp: [''],
      pr_rstSts_travel: [false],
      pr_rstSts_trvl_desc: [''],
      pr_rstSts_baccount: [''],
      pr_insuranceInfos: [false, Validators.required],
      insuranceArray: this.fb.array([
        this.fb.group({
          cmpany: [''],
          sum: ['']
        })
      ]),
      // pr_cmpany: [''],
      // pr_sum_assured: [''],
      // pr_sum_totalamount: [{ disabled: true, value: '' }],
    });

    this.MwpaDetailsForm = this.fb.group({
      lf_mwpaOpted: [false, Validators.required],
      // lf_br_lstNm: [''],
      // lf_br_frstNm: [''],
      // lf_br_dob: [''],
      // lf_br_relationWithLa: [''],
      // lf_br_share: [''],
      beneficiaryArray: this.fb.array([
        this.fb.group({
          frstNm: [''],
          lstNm: [''],
          relationship: [''],
          dob: [''],
          shareOfBenefit: ['', [Validators.max(this.maxShareAllowed)]],
          // isMinor: [''],
        })
      ]),

      lf_nm_frstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
      lf_nm_lstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
      lf_nm_dob: ['', Validators.required],
      lf_nm_gender: ['', Validators.required],
      lf_nm_relationWithLa: ['', Validators.required],
      lf_ap_frstNm: [''],
      lf_ap_lstNm: [''],
      lf_ap_gender: [''],
      lf_ap_dob: [''],
      lf_ap_relationWithLa: [''],
      lf_tr_frstNm: ['', [Validators.minLength(1), Validators.maxLength(30)]],
      lf_tr_dob: [''],
      lf_tr_salutn: [''],
      lf_tr_relationWithLa: [''],
      lf_tr_pincode: ['', [Validators.minLength(6), Validators.maxLength(6)]],
      lf_tr_address: [''],
      lf_tr_city: [''],
      lf_tr_panNo: ['', [Validators.pattern("[A-Za-z]{5}\d{4}[A-Za-z]{1}")]],
      lf_tr_mobNo: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      lf_tr_email: ['', [Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      lf_tr_state: ['']
    });

    this.HealthDetailsForm = this.fb.group({
      hl_height_feet: ['', Validators.required],
      hl_height_inch: ['', Validators.required],
      hl_weight: ['', Validators.required],
      hl_tabacoo: ['', Validators.required],
      hl_consumption_period: [''],
      hl_quant_day: [''],
      hl_tabaco_years: [''],
      hl_alcohol: ['', Validators.required],
      hl_alch_period: [''],
      hl_alch_day: [''],
      hl_alch_years: [''],
      hl_narcotics: ['', Validators.required],
      hl_chemical_exposure: ['', Validators.required],
      hl_remark_descrptn: [''],
      hl_army_emply: ['', Validators.required],
      hl_army_descrptn: [''],
      hl_lost_wgts: ['', Validators.required],
      hl_lostwgts_descrptn: [''],
      hl_fmly_illnes: ['', Validators.required],
      hl_fmlyillnes_descrptn: [''],
      hl_surgery: ['', Validators.required],
      hl_surgery_descrptn: [''],
      hl_answer1: [false],
      hl_answer2: [false],
      hl_answer3: [false],
      hl_answer4: [false],
      hl_answer5: [false],
      hl_answer6: [false],
      hl_answer7: [false],
      hl_answer8: [false],
      hl_answer9: [false],
      hl_answer10: [false],
      hl_answer11: [false],
      hl_answer12: [false],
      hl_answer13: [false],
      hl_answer14: [false],
      hl_answer15: [false],
      hl_slecet_descrptn: [''],
      hl_declartion_form: [''],
      hl_medi_condn: [''],
      hl_medical_diagnosis: [''],
      hl_medical_treatmt: [''],
      hl_med_currntstg: [''],
      hl_medical_detls: [''],
      hl_medical_testundgne: [''],
      hl_medical_othrdtls: [''],
      hl_med_suffering: ['', Validators.required],
      hl_medsuffrng_descrptn: [''],
      hl_med_handicap: ['', Validators.required],
      hl_medhandicap_descrptn: [''],
      hl_med_injury: ['', Validators.required],
      hl_medinjury_descrptn: [''],
      hl_pregant: [''],
      hl_pregnant_weeks: [''],
      hl_covid_test: ['No'],
      hl_covid_selfisolated: ['No'],
      hl_covid_advice: ['No'],
      hl_covid_cough: ['No'],
      hl_covid_office: ['No'],
      hl_covid_everTested: ['', Validators.required],
      hl_covid_fullyRecovered: [''],
      hl_covid_dateOfDiagnosis: [''],
      hl_covid_dateOfRecovery: [''],
      hl_covid_hospital: [''],
      hl_covid_coughAdvice: ['', Validators.required],
      hl_covid_famSelfisolated: ['', Validators.required],
      hl_covid_coronaWarrior: ['', Validators.required],
      hl_covid_travel: ['No'],
      hl_covid_travelCountry: [''],
      hl_covid_arrivalDt: [''],
      hl_covid_leavingDt: [''],
      hl_covid_vaccine: ['No'],
      hl_covid_vaccineSideEffect: [''],
      hl_covid_vaccineSideEffectHospital: [''],
      hl_covid_vaccineSideEffectDetails: [''],
      hl_covid_isVaccinated: ['', Validators.required],
      hl_covid_1stDoseDate: [''],
      hl_covid_1stDoseName: [''],
      hl_covid_isVaccinated2ndDose: [''],
      hl_covid_2ndDoseDate: [''],
      hl_covid_2ndDoseName: [''],
      hl_covid_outsideInd: ['', Validators.required],
      hl_covid_outsideIndCountry: [''],
      hl_covid_outsideIndCity: [''],
      hl_covid_outsideIndDateOfTarvel: [''],
      hl_covid_outsideIndIndentedMonth: [''],
      hl_covid_travel14: ['', Validators.required],
      hl_covid_travel14Country: [''],
      hl_covid_travel14City: [''],
      hl_covid_travel14DateArrived: [''],
      hl_covid_travel14DateDeptd: [''],
      hl_covid_travel3M: ['', Validators.required],
      hl_covid_travel3MCountry: [''],
      hl_covid_travel3MCity: [''],
      hl_covid_travel3MDateOfTarvel: [''],
      hl_covid_travel3MIndentedMonth: [''],
    });

    this.UploadDocumentsDetailsForm = this.fb.group({
      up_itPrf: ['', Validators.required],
      up_panNo: ['', Validators.pattern("[A-Za-z]{5}\d{4}[A-Za-z]{1}")],
      // up_aadharCardNo: ['', [Validators.pattern("[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$"), Validators.required, Validators.minLength(14), Validators.maxLength(14)]],
      up_aadharCardNo: ['', [Validators.pattern("[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$"), Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
      up_agePrf: ['', Validators.required],
      up_addPrf: ['', Validators.required],
      up_incomePrf: ['', Validators.required],
      up_idPrf: ['', Validators.required],
      up_pic_sub: [false, Validators.required],
    });

    this.paymentDocumentsForm = this.fb.group({
      // pay_banknmber: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(40)]],
      // pay_acc_name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
      // pay_micr: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
      // pay_bnk_brch: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(40)]],
      // pay_bnk_nme: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(40)]],
      // pay_acc_type: ['', Validators.required],
      // pay_ifsc_code: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      // pay_paymt_mode: ['', Validators.required],
      // pay_paymt_frequency: ['', Validators.required],
      // pay_amount: ['', Validators.required],
      // pay_cheq_dd: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]],
      pay_third_party: [false],
      pay_ele_ins: [false, Validators.required],
      pay_eia_num: [''],
      pay_ins_repo: ['', Validators.required],
      pay_ele_convt: [false, Validators.required]
    });

    this.relationshipWithLA = this._dataFields.getRelationOfPRtoLA();

    this.genderlist = this._dataFields.getGenderList().sort((a, b) => a.label.localeCompare(b.label));
    this.maritalstatuslist = this._dataFields.getMaritalStatusList().sort((a, b) => a.label.localeCompare(b.label));
    this.genderlist = this._dataFields.getGenderList().sort((a, b) => a.label.localeCompare(b.label));
    this.educationlist = this._dataFields.getEducationList().sort((a, b) => a.label.localeCompare(b.label));
    this.occupationlist = this._dataFields.getOccupationList().sort((a, b) => a.label.localeCompare(b.label));
    this.myprofessionlist = this._dataFields.getMyProfessionList().sort((a, b) => a.label.localeCompare(b.label));
    this.organisationotherslist = this._dataFields.getOrganisationTypeOthersList().sort((a, b) => a.label.localeCompare(b.label));
    this.industrytypelist = this._dataFields.getIndustryTypeList().sort((a, b) => a.label.localeCompare(b.label));
    this.organsiationselfemployed = this._dataFields.getOrganisationSelfEmployedList().sort((a, b) => a.label.localeCompare(b.label));
    this.sourceofincome = this._dataFields.getSourceOfFundList().sort((a, b) => a.label.localeCompare(b.label));
    this.objectivepolicy = this._dataFields.getObjectiveOfPolicyBuying().sort((a, b) => a.label.localeCompare(b.label));
    this.statelist = this._dataFields.getStateList().sort((a, b) => a.label.localeCompare(b.label));
    this.countrylist = this._dataFields.getCountryList().sort((a, b) => a.label.localeCompare(b.label));
    this.nationalitylist = this._dataFields.getNationalityList().sort((a, b) => a.label.localeCompare(b.label));
    this.residentallist = this._dataFields.getResidentStatusList().sort((a, b) => a.label.localeCompare(b.label));
    this.residentallistnonindian = this._dataFields.getResidentStatusNonIdian().sort((a, b) => a.label.localeCompare(b.label));
    this.insurancecompanylist = this._dataFields.getInsuranceCompanyList().sort((a, b) => a.label.localeCompare(b.label));
    this.relationshiptopropser = this._dataFields.getRelationOfPRtoLA().sort((a, b) => a.label.localeCompare(b.label));
    this.trusteelist = this._dataFields.getTrusteeTypeList().sort((a, b) => a.label.localeCompare(b.label));
    this.tobacoconsumed = this._dataFields.getTobaccoConsumedAs().sort((a, b) => a.label.localeCompare(b.label));
    this.tobaccoqtylist = this._dataFields.getTobaccoQtyList().sort((a, b) => a.label.localeCompare(b.label));
    this.alcoholconsumedas = this._dataFields.getAlcoholConsumedAs().sort((a, b) => a.label.localeCompare(b.label));
    this.alcoholqtylist = this._dataFields.getAlcoholQtyList().sort((a, b) => a.label.localeCompare(b.label));
    this.idproof = this._dataFields.getIdProof().sort((a, b) => a.label.localeCompare(b.label));
    this.ageproof = this._dataFields.getAgeProof().sort((a, b) => a.label.localeCompare(b.label));
    this.addressproof = this._dataFields.getAddressProof().sort((a, b) => a.label.localeCompare(b.label));
    this.incomeproof = this._dataFields.getIncomeProof().sort((a, b) => a.label.localeCompare(b.label));
    this.itproof = this._dataFields.getItProof().sort((a, b) => a.label.localeCompare(b.label));
    this.relationoflatoPR = this._dataFields.getRelationOfLAtoPR().sort((a, b) => a.label.localeCompare(b.label));
    this.eiadetailsList = this._dataFields.getEiaDetailsList().sort((a, b) => a.label.localeCompare(b.label));
    this.accounttypelist = this._dataFields.getAccountTypeList().sort((a, b) => a.label.localeCompare(b.label));
    this.modeofdepositelist = this._dataFields.getModeOfDeposite().sort((a, b) => a.label.localeCompare(b.label));
    this.modeofpayFrequency = this._dataFields.getPayFrequency().sort((a, b) => a.label.localeCompare(b.label));
    this.nomineerelationship = this._dataFields.getNomineeRelationshipList().sort((a, b) => a.label.localeCompare(b.label));
    this.relationofMWPAbeneficiarytoPR = this._dataFields.getRelationOfMWPABeneficiarytoPR().sort((a, b) => a.label.localeCompare(b.label));
    this.salutationlist = this._dataFields.getSalutationList().sort((a, b) => a.label.localeCompare(b.label));
    // this.nameoforganisation = this._dataFields.getNameOfOrganisation();
  }

  relationshipWithLA: any;

  validateSelfProposed() {
    this.dependflagResponse = {
      // "dependentFlag": this.proposerDetailsForm.get('pr_selfProposed').value,
      "dependentFlag": "N",
      "relationWithLa": this.proposerDetailsForm.get('pr_relWithLA').value,
    }
    this.checkLARequired();
  }

  checkLARequired() {
    console.log("***** checkLA ******", this.upgradedQuoteResponseObj)
    // setTimeout(() => {
    console.log(this.quoteFormResObj, 'quoteobject');
    console.log(this.dependflagResponse, 'dependflagresponse');
    if (this.dependflagResponse.dependentFlag === "Y") {
      this.proposerDetailsForm.get('pr_relWithLA').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_relWithLA').updateValueAndValidity();
      this.showLifeassuredformbtn = true;
      this.showLifeassuredForm = false;
      this.disablelf_DOB = true;
      this.disablepr_DOB = false;
      this.LifeDetailsForm = this.fb.group({
        lf_frstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
        lf_lstNm: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]],
        lf_dob: [{ disabled: this.disablelf_DOB, value: '' }, Validators.required],
        lf_gender: [{ disabled: this.disablelf_DOB, value: '' }, Validators.required],
        lf_mrtlSts: ['', Validators.required],
        lf_spouseName: [''],
        lf_education: ['', Validators.required],
        lf_occ: ['', Validators.required],
        lf_myprof: [''],
        lf_orgType: [''],
        lf_org_selfemployed: [''],
        lf_orgTypeDesc: [''],
        lf_indsType: [''],
        lf_occDesc: [''],
        lf_nameOfOrg: [''],
        lf_nameOfOrgdecstn: [''],
        lf_annlncme: ['', Validators.required],
        lf_nationality: ['', Validators.required],
        lf_mobNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
        lf_pincode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
        lf_rstSts: [''],
        lf_rstSts_NIndian: [''],
        lf_rstSts_nri: [''],
        lf_rstSts_nri_country: [''],
        lf_rstSts_nri_nationlity: [''],
        lf_rstSts_tin1_contry: [''],
        lf_rstSts_tin1_pan1: ['', Validators.pattern("[A-Za-z]{5}\d{4}[A-Za-z]{1}")],
        lf_rstSts_tin2_contry: [''],
        lf_rstSts_tin2_pan2: ['', Validators.pattern("[A-Za-z]{5}\d{4}[A-Za-z]{1}")],
        lf_rstSts_passport: [''],
        lf_rstSts_DOA: [''],
        lf_rstSts_DOL: [''],
        lf_rstSts_DOS: [''],
        lf_rstSts_DOSM: [''],
        lf_rstSts_purpse: [''],
        lf_rstSts_emp: [''],
        lf_rstSts_travel: [false],
        lf_rstSts_trvl_desc: [''],
        lf_rstSts_baccount: [''],
      });
      if (this.dependflagResponse.relationWithLa === "Spouse") {
        this.proposerDetailsForm.get('pr_mrtlSts').setValue("696");
        this.showspouse = true;
      }
      else {
        this.proposerDetailsForm.get('pr_mrtlSts').setValue("");
        this.showspouse = false;
      }
      this.proposerDetailsForm.get('pr_dob').setValue("");
      this.proposerDetailsForm.get('pr_email').setValue("");
      this.proposerDetailsForm.get('pr_gender').setValue("");
      this.proposerDetailsForm.get('pr_frstNm').setValue("");
      this.proposerDetailsForm.get('pr_lstNm').setValue("");
      this.proposerDetailsForm.get('pr_annlncme').setValue("");
      this.LifeDetailsForm.get('lf_dob').setValue(this.upgradedQuoteResponseObj.dateOfBirth);
      this.LifeDetailsForm.get('lf_gender').setValue(this.upgradedQuoteResponseObj.gender);
      this.LifeDetailsForm.get('lf_frstNm').setValue(this.quoteFormResObj.qt_fname);
      this.LifeDetailsForm.get('lf_lstNm').setValue(this.quoteFormResObj.qt_lname);
      this.LifeDetailsForm.get('lf_annlncme').setValue(this.quoteFormResObj.qt_annualIncome);
    }
    else {
      console.log('wont show life assused form');
      this.proposerDetailsForm.get('pr_relWithLA').clearValidators();
      this.proposerDetailsForm.get('pr_relWithLA').updateValueAndValidity();
      this.showLifeassuredformbtn = false;
      this.showLifeassuredForm = false;
      this.disablelf_DOB = false;
      this.disablepr_DOB = true;
      this.proposerDetailsForm.get('pr_dob').setValue(this.upgradedQuoteResponseObj.dateOfBirth);
      this.proposerDetailsForm.get('pr_email').setValue(this.userObj.email);
      this.proposerDetailsForm.get('pr_gender').setValue(this.upgradedQuoteResponseObj.gender);
      this.proposerDetailsForm.get('pr_frstNm').setValue(this.quoteFormResObj.qt_fname);
      this.proposerDetailsForm.get('pr_lstNm').setValue(this.quoteFormResObj.qt_lname);
      this.proposerDetailsForm.get('pr_annlncme').setValue(this.quoteFormResObj.qt_annualIncome);
      // this.LifeDetailsForm.get('lf_dob').setValue("");
      // this.LifeDetailsForm.get('lf_dob').clearValidators();
      // this.LifeDetailsForm.get('lf_dob').updateValueAndValidity();
      // this.LifeDetailsForm.get('lf_gender').setValue("");
      // this.LifeDetailsForm.get('lf_gender').clearValidators();
      // this.LifeDetailsForm.get('lf_gender').updateValueAndValidity();
      // this.LifeDetailsForm.get('lf_frstNm').setValue("");
      // this.LifeDetailsForm.get('lf_frstNm').clearValidators();
      // this.LifeDetailsForm.get('lf_frstNm').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_lstNm').setValue("");
      // this.LifeDetailsForm.get('lf_lstNm').clearValidators();
      // this.LifeDetailsForm.get('lf_lstNm').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_mrtlSts').setValue("");
      // this.LifeDetailsForm.get('lf_mrtlSts').clearValidators();
      // this.LifeDetailsForm.get('lf_mrtlSts').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_education').setValue("");
      // this.LifeDetailsForm.get('lf_education').clearValidators();
      // this.LifeDetailsForm.get('lf_education').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_occ').setValue("");
      // this.LifeDetailsForm.get('lf_occ').clearValidators();
      // this.LifeDetailsForm.get('lf_occ').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_annlncme').setValue("");
      // this.LifeDetailsForm.get('lf_annlncme').clearValidators();
      // this.LifeDetailsForm.get('lf_annlncme').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_nationality').setValue("");
      // this.LifeDetailsForm.get('lf_nationality').clearValidators();
      // this.LifeDetailsForm.get('lf_nationality').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_mobNo').setValue("");
      // this.LifeDetailsForm.get('lf_mobNo').clearValidators();
      // this.LifeDetailsForm.get('lf_mobNo').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_pincode').setValue("");
      // this.LifeDetailsForm.get('lf_pincode').clearValidators();
      // this.LifeDetailsForm.get('lf_pincode').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').setValue("");
      // this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').clearValidators();
      // this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').setValue("");
      // this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').clearValidators();
      // this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').updateValueAndValidity();

      // this.LifeDetailsForm.get('lf_rstSts_travel').setValue("");
      // this.LifeDetailsForm.get('lf_rstSts_travel').clearValidators();
      // this.LifeDetailsForm.get('lf_rstSts_travel').updateValueAndValidity();
    }
    // }, 2000);
  }

  //only letter validation
  validateLettersOnly(event) {
    console.log("target", event);
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  // NUMERICS only validation
  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }

  //proposal other fields
  proposerOtherFieldsValidation(event?) {
    console.log("hiii", event);
    if (this.proposerDetailsForm.get('pr_mrtlSts').value === "696") {
      this.showspouse = true;
      this.proposerDetailsForm.get('pr_spouseName').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_spouseName').updateValueAndValidity();
    }
    else {
      this.showspouse = false;
      this.proposerDetailsForm.get('pr_spouseName').clearValidators();
      this.proposerDetailsForm.get('pr_spouseName').setValue("");
      this.proposerDetailsForm.get('pr_spouseName').updateValueAndValidity();
    }
    //toggle source of fund description
    if (this.proposerDetailsForm.get('pr_sourceOfFund').value === "Others") {
      this.showprsourceOfFundDesc = true;
      this.proposerDetailsForm.get('pr_sourceOfFundDesc').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_sourceOfFundDesc').updateValueAndValidity();
    }
    else {
      this.showprsourceOfFundDesc = false;
      this.proposerDetailsForm.get('pr_sourceOfFundDesc').clearValidators();
      this.proposerDetailsForm.get('pr_sourceOfFundDesc').setValue("");
      this.proposerDetailsForm.get('pr_sourceOfFundDesc').updateValueAndValidity();
    }
    //toggle objective description
    if (this.proposerDetailsForm.get('pr_objective').value === "Others") {
      this.showprobjective = true;
      this.proposerDetailsForm.get('pr_objective_others').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_objective_others').updateValueAndValidity();
    }
    else {
      this.showprobjective = false;
      this.proposerDetailsForm.get('pr_objective_others').clearValidators();
      this.proposerDetailsForm.get('pr_objective_others').setValue("");
      this.proposerDetailsForm.get('pr_objective_others').updateValueAndValidity();
    }
    //toggle insurance
    if (this.proposerDetailsForm.get('pr_insuranceInfos').value === true) {
      this.showinsurancedetails = true;
      this.insArray.controls.forEach(f => {
        f.get('cmpany').setValidators(Validators.required);
        f.get('cmpany').updateValueAndValidity();
        f.get('sum').setValidators(Validators.required);
        f.get('sum').updateValueAndValidity();
      });
    }
    else {
      this.showinsurancedetails = false;
      this.insArray.controls.forEach(f => {
        f.get('cmpany').setValue("");
        f.get('cmpany').clearValidators();
        f.get('cmpany').updateValueAndValidity();
        f.get('sum').setValue("");
        f.get('sum').clearValidators();
        f.get('sum').updateValueAndValidity();
      })
    }
    //toggle residential status
    if (this.proposerDetailsForm.get('pr_nationality').value === "Indian") {
      this.showproposerresidential = true;
      this.showpropres_nonindian = false;
      this.proposerDetailsForm.get('pr_rstSts').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts_NIndian').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_NIndian').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_NIndian').updateValueAndValidity();

    }
    else if (this.proposerDetailsForm.get('pr_nationality').value === "Non indian") {
      this.showpropres_nonindian = true;
      this.showproposerresidential = false;
      this.proposerDetailsForm.get('pr_rstSts_NIndian').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_NIndian').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts').setValue("");
      this.proposerDetailsForm.get('pr_rstSts').updateValueAndValidity();

    }
    else {
      this.showproposerresidential = false;
      this.showpropres_nonindian = false;
      this.proposerDetailsForm.get('pr_rstSts').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts').setValue("");
      this.proposerDetailsForm.get('pr_rstSts').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_NIndian').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_NIndian').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_NIndian').updateValueAndValidity();
    }
  }

  //occcupation validation for proposer
  occupationValidate() {
    if (this.proposerDetailsForm.get('pr_occ').value === "PROF" ||
      this.proposerDetailsForm.get('pr_occ').value === "SECO") {
      this.showProfession = true;
      this.showOccDesc = false;
      this.showIndustypeQues = false;
      this.showOcctypeOC = false;
      this.showselfemplyoed = false;
      this.showNameoforgn = false;
      this.shownameoforgansdecrptn = false;
      this.showindustry = false;
      this.proposerDetailsForm.get('pr_myprof').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_myprof').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_occDesc').clearValidators();
      this.proposerDetailsForm.get('pr_occDesc').setValue("");
      this.proposerDetailsForm.get('pr_occDesc').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsTypeQuestion').clearValidators();
      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValue("");
      this.proposerDetailsForm.get('pr_indsTypeQuestion').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_orgType').clearValidators();
      this.proposerDetailsForm.get('pr_orgType').setValue("");
      this.proposerDetailsForm.get('pr_orgType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_org_selfemployed').clearValidators();
      this.proposerDetailsForm.get('pr_org_selfemployed').setValue("");
      this.proposerDetailsForm.get('pr_org_selfemployed').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrg').clearValidators();
      this.proposerDetailsForm.get('pr_nameOfOrg').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrg').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').clearValidators();
      // this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();
    }
    else if (this.proposerDetailsForm.get('pr_occ').value === "SEBU" ||
      this.proposerDetailsForm.get('pr_occ').value === "SEOT") {
      this.showOcctypeOC = true;
      this.shownameoforgansdecrptn = false;
      this.showProfession = false;
      this.showOccDesc = false;
      this.showselfemplyoed = false;
      this.showIndustypeQues = false;
      this.showindustry = false;
      this.showNameoforgn = false;
      this.proposerDetailsForm.get('pr_nameOfOrg').clearValidators();
      this.proposerDetailsForm.get('pr_nameOfOrg').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrg').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').clearValidators();
      // this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_orgType').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_orgType').updateValueAndValidity()

      this.proposerDetailsForm.get('pr_myprof').clearValidators();
      this.proposerDetailsForm.get('pr_myprof').setValue("");
      this.proposerDetailsForm.get('pr_myprof').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_occDesc').setValue("");
      this.proposerDetailsForm.get('pr_occDesc').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_occDesc').clearValidators();

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_org_selfemployed').setValue("");
      this.proposerDetailsForm.get('pr_org_selfemployed').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_org_selfemployed').clearValidators();

      this.proposerDetailsForm.get('pr_indsTypeQuestion').clearValidators();
      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValue("");
      this.proposerDetailsForm.get('pr_indsTypeQuestion').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();

    }
    else if (this.proposerDetailsForm.get('pr_occ').value === "SPRO") {
      this.showIndustypeQues = true;
      this.showOccDesc = true;
      this.showNameoforgn = true;
      this.showOcctypeOC = true;
      this.showselfemplyoed = false;
      this.showProfession = false;
      this.shownameoforgansdecrptn = false;
      this.showindustry = false;

      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').clearValidators();
      // this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();

      this.proposerDetailsForm.get("pr_occDesc").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30)
      ]);
      this.proposerDetailsForm.get('pr_occDesc').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_orgType').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_orgType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValue(false);
      this.proposerDetailsForm.get('pr_indsTypeQuestion').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrg').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_nameOfOrg').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_org_selfemployed').clearValidators();
      this.proposerDetailsForm.get('pr_org_selfemployed').setValue("");
      this.proposerDetailsForm.get('pr_org_selfemployed').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_myprof').clearValidators();
      this.proposerDetailsForm.get('pr_myprof').setValue("");
      this.proposerDetailsForm.get('pr_myprof').updateValueAndValidity();

    }
    else if (this.proposerDetailsForm.get('pr_occ').value === "SPVT") {
      this.showNameoforgn = true;
      this.shownameoforgansdecrptn = false;
      this.showIndustypeQues = true;
      this.showOcctypeOC = true;
      this.showselfemplyoed = false;
      this.showProfession = false;
      this.showOccDesc = false;
      this.showindustry = false;

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValue(false);
      this.proposerDetailsForm.get('pr_indsTypeQuestion').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_orgType').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_orgType').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_nameOfOrg').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_nameOfOrg').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_org_selfemployed').clearValidators();
      this.proposerDetailsForm.get('pr_org_selfemployed').setValue("");
      this.proposerDetailsForm.get('pr_org_selfemployed').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_myprof').clearValidators();
      this.proposerDetailsForm.get('pr_myprof').setValue("");
      this.proposerDetailsForm.get('pr_myprof').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_occDesc').clearValidators();
      this.proposerDetailsForm.get('pr_occDesc').setValue("");
      this.proposerDetailsForm.get('pr_occDesc').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').clearValidators();
      // this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();

    }
    else if (this.proposerDetailsForm.get('pr_occ').value === "BSEM") {
      this.showselfemplyoed = true;
      this.showIndustypeQues = true;
      this.shownameoforgansdecrptn = true;
      this.showOcctypeOC = false;
      this.showProfession = false;
      this.showOccDesc = false;
      this.showNameoforgn = false;
      this.showindustry = false;

      this.proposerDetailsForm.get('pr_nameOfOrg').clearValidators();
      this.proposerDetailsForm.get('pr_nameOfOrg').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrg').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValue(false);
      this.proposerDetailsForm.get('pr_indsTypeQuestion').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_org_selfemployed').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_org_selfemployed').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_orgType').clearValidators();
      this.proposerDetailsForm.get('pr_orgType').setValue("");
      this.proposerDetailsForm.get('pr_orgType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_myprof').clearValidators();
      this.proposerDetailsForm.get('pr_myprof').setValue("");
      this.proposerDetailsForm.get('pr_myprof').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_occDesc').clearValidators();
      this.proposerDetailsForm.get('pr_occDesc').setValue("");
      this.proposerDetailsForm.get('pr_occDesc').updateValueAndValidity();
    }
    else {
      this.showProfession = false;
      this.showOccDesc = false;
      this.showIndustypeQues = false;
      this.showselfemplyoed = false;
      this.showOcctypeOC = false;
      this.showNameoforgn = false;
      this.showindustry = false;
      this.shownameoforgansdecrptn = false;

      this.proposerDetailsForm.get('pr_myprof').clearValidators();
      this.proposerDetailsForm.get('pr_myprof').setValue("");
      this.proposerDetailsForm.get('pr_myprof').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_occDesc').clearValidators();
      this.proposerDetailsForm.get('pr_occDesc').setValue("");
      this.proposerDetailsForm.get('pr_occDesc').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsTypeQuestion').clearValidators();
      this.proposerDetailsForm.get('pr_indsTypeQuestion').setValue("");
      this.proposerDetailsForm.get('pr_indsTypeQuestion').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_orgType').clearValidators();
      this.proposerDetailsForm.get('pr_orgType').setValue("");
      this.proposerDetailsForm.get('pr_orgType').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_org_selfemployed').clearValidators();
      this.proposerDetailsForm.get('pr_org_selfemployed').setValue("");
      this.proposerDetailsForm.get('pr_org_selfemployed').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrg').clearValidators();
      this.proposerDetailsForm.get('pr_nameOfOrg').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrg').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').clearValidators();
      // this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();
    }
  }

  //occupation validation for lifeAssueed
  occupationValidateLifeAssured() {
    //toggle organisation
    if (this.LifeDetailsForm.get('lf_occ').value === "PROF" ||
      this.LifeDetailsForm.get('lf_occ').value === "SECO") {
      this.showProfession_lf = true;
      this.showOccDesc_lf = false;
      this.showOcctypeOC_lf = false;
      this.showselfemplyoed_lf = false;
      this.showNameoforgn_lf = false;
      this.shownameoforgansdecrptn_lf = false;

      this.LifeDetailsForm.get('lf_myprof').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_myprof').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_occDesc').clearValidators();
      this.LifeDetailsForm.get('lf_occDesc').setValue("");
      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_orgType').clearValidators();
      this.LifeDetailsForm.get('lf_orgType').setValue("");
      this.LifeDetailsForm.get('lf_orgType').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_org_selfemployed').clearValidators();
      this.LifeDetailsForm.get('lf_org_selfemployed').setValue("");
      this.LifeDetailsForm.get('lf_org_selfemployed').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrg').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrg').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrg').updateValueAndValidity();
    }
    else if (this.LifeDetailsForm.get('lf_occ').value === "SEBU" ||
      this.LifeDetailsForm.get('lf_occ').value === "SEOT") {
      this.showOcctypeOC_lf = true;
      this.showNameoforgn_lf = false;
      this.showselfemplyoed_lf = false;
      this.showProfession_lf = false;
      this.showOccDesc_lf = false;
      this.shownameoforgansdecrptn_lf = false;

      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_orgType').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_orgType').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrg').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrg').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrg').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_org_selfemployed').clearValidators();
      this.LifeDetailsForm.get('lf_org_selfemployed').setValue("");
      this.LifeDetailsForm.get('lf_org_selfemployed').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_myprof').clearValidators();
      this.LifeDetailsForm.get('lf_myprof').setValue("");
      this.LifeDetailsForm.get('lf_myprof').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_occDesc').clearValidators();
      this.LifeDetailsForm.get('lf_occDesc').setValue("");
      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();

    }
    else if (this.LifeDetailsForm.get('lf_occ').value === "SPRO") {
      this.showOccDesc_lf = true;
      this.showNameoforgn_lf = true;
      this.showOcctypeOC_lf = true;
      this.showselfemplyoed_lf = false;
      this.showProfession_lf = false;
      this.shownameoforgansdecrptn_lf = false;

      this.LifeDetailsForm.get("lf_occDesc").setValidators([
        Validators.required,
      ]);
      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_orgType').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_orgType').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_nameOfOrg').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_nameOfOrg').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_org_selfemployed').clearValidators();
      this.LifeDetailsForm.get('lf_org_selfemployed').setValue("");
      this.LifeDetailsForm.get('lf_org_selfemployed').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_myprof').clearValidators();
      this.LifeDetailsForm.get('lf_myprof').setValue("");
      this.LifeDetailsForm.get('lf_myprof').updateValueAndValidity();

    }
    else if (this.LifeDetailsForm.get('lf_occ').value === "SPVT") {
      this.showOcctypeOC_lf = true;
      this.showNameoforgn_lf = true;
      this.showselfemplyoed_lf = false;
      this.showProfession_lf = false;
      this.showOccDesc_lf = false;
      this.shownameoforgansdecrptn_lf = false;

      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_orgType').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_orgType').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_nameOfOrg').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_nameOfOrg').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_org_selfemployed').clearValidators();
      this.LifeDetailsForm.get('lf_org_selfemployed').setValue("");
      this.LifeDetailsForm.get('lf_org_selfemployed').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_myprof').clearValidators();
      this.LifeDetailsForm.get('lf_myprof').setValue("");
      this.LifeDetailsForm.get('lf_myprof').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_occDesc').clearValidators();
      this.LifeDetailsForm.get('lf_occDesc').setValue("");
      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();

    }
    else if (this.LifeDetailsForm.get('lf_occ').value === "BSEM") {
      this.showselfemplyoed_lf = true;
      this.showNameoforgn_lf = false;
      this.showOcctypeOC_lf = false;
      this.showProfession_lf = false;
      this.showOccDesc_lf = false;
      this.shownameoforgansdecrptn_lf = true;

      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_org_selfemployed').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_org_selfemployed').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_orgType').clearValidators();
      this.LifeDetailsForm.get('lf_orgType').setValue("");
      this.LifeDetailsForm.get('lf_orgType').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrg').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrg').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrg').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_myprof').clearValidators();
      this.LifeDetailsForm.get('lf_myprof').setValue("");
      this.LifeDetailsForm.get('lf_myprof').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_occDesc').clearValidators();
      this.LifeDetailsForm.get('lf_occDesc').setValue("");
      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();
    }
    else {
      this.showNameoforgn_lf = false;
      this.showProfession_lf = false;
      this.showOccDesc_lf = false;
      this.showselfemplyoed_lf = false;
      this.showOcctypeOC_lf = false;
      this.shownameoforgansdecrptn_lf = false;

      this.LifeDetailsForm.get('lf_myprof').clearValidators();
      this.LifeDetailsForm.get('lf_myprof').setValue("");
      this.LifeDetailsForm.get('lf_myprof').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_occDesc').clearValidators();
      this.LifeDetailsForm.get('lf_occDesc').setValue("");
      this.LifeDetailsForm.get('lf_occDesc').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_orgType').clearValidators();
      this.LifeDetailsForm.get('lf_orgType').setValue("");
      this.LifeDetailsForm.get('lf_orgType').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_org_selfemployed').clearValidators();
      this.LifeDetailsForm.get('lf_org_selfemployed').setValue("");
      this.LifeDetailsForm.get('lf_org_selfemployed').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_nameOfOrg').clearValidators();
      this.LifeDetailsForm.get('lf_nameOfOrg').setValue("");
      this.LifeDetailsForm.get('lf_nameOfOrg').updateValueAndValidity();
    }

  }

  //organisation validation for proposer
  organisationvalidate() {
    if (this.proposerDetailsForm.get('pr_orgType').value === "NOT ANSWERED" ||
      this.proposerDetailsForm.get('pr_org_selfemployed').value === "NOT ANSWERED") {
      this.showorgdesc = true;
      this.proposerDetailsForm.get("pr_orgTypeDesc").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30)
      ]);
      this.proposerDetailsForm.get('pr_orgTypeDesc').updateValueAndValidity();
    }
    else {
      this.showorgdesc = false;
      this.proposerDetailsForm.get('pr_orgTypeDesc').clearValidators();
      this.proposerDetailsForm.get('pr_orgTypeDesc').setValue("");
      this.proposerDetailsForm.get('pr_orgTypeDesc').updateValueAndValidity();
    }
  }

  //nri validation for proposer
  nationalityValidate() {
    //toggle nri status
    if (this.proposerDetailsForm.get('pr_rstSts').value === "NRI" || this.proposerDetailsForm.get('pr_rstSts_NIndian').value === "PIO" || this.proposerDetailsForm.get('pr_rstSts_NIndian').value === "Foreign National") {
      this.showNRIProposer = true;
      this.proposerDetailsForm.get('pr_rstSts_nri').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_nri').setValue(false);
      this.proposerDetailsForm.get('pr_rstSts_nri').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts_nri_nationlity').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_nri_nationlity').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_nri_country').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_nri_country').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin1_contry').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_tin1_contry').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin1_pan1').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_tin1_pan1').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin2_contry').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_tin2_contry').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin2_pan2').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_tin2_pan2').updateValueAndValidity();

      this.proposerDetailsForm.get("pr_rstSts_passport").setValidators([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(15)
      ]);
      this.proposerDetailsForm.get('pr_rstSts_passport').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts_DOA').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_DOA').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts_DOL').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_DOL').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts_DOS').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_DOS').updateValueAndValidity();
      this.proposerDetailsForm.get('pr_rstSts_DOSM').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_rstSts_DOSM').updateValueAndValidity();
      this.proposerDetailsForm.get("pr_rstSts_purpse").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]);
      this.proposerDetailsForm.get('pr_rstSts_purpse').updateValueAndValidity();
      this.proposerDetailsForm.get("pr_rstSts_emp").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]);
      this.proposerDetailsForm.get('pr_rstSts_emp').updateValueAndValidity();
    }
    else {
      this.showNRIProposer = false;
      this.proposerDetailsForm.get('pr_rstSts_nri').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_nri').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_nri').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_nri_nationlity').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_nri_nationlity').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_nri_nationlity').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_nri_country').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_nri_country').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_nri_country').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin1_contry').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_tin1_contry').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_tin1_contry').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin1_pan1').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_tin1_pan1').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_tin1_pan1').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin2_contry').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_tin2_contry').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_tin2_contry').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_tin2_pan2').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_tin2_pan2').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_tin2_pan2').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_passport').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_passport').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_passport').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_DOA').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_DOA').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_DOA').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_DOL').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_DOA').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_DOL').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_DOS').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_DOS').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_DOS').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_DOSM').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_DOSM').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_DOSM').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_purpse').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_purpse').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_purpse').updateValueAndValidity();

      this.proposerDetailsForm.get('pr_rstSts_emp').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_emp').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_emp').updateValueAndValidity();

    }
    //toggle travel description
    if (this.proposerDetailsForm.get('pr_rstSts_travel').value === true) {
      this.showpr_NRItraveldetails = true;
      this.proposerDetailsForm.get("pr_rstSts_trvl_desc").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]);
      this.proposerDetailsForm.get('pr_rstSts_trvl_desc').updateValueAndValidity();
    }
    else {
      this.showpr_NRItraveldetails = false;
      this.proposerDetailsForm.get('pr_rstSts_trvl_desc').setValue("");
      this.proposerDetailsForm.get('pr_rstSts_trvl_desc').clearValidators();
      this.proposerDetailsForm.get('pr_rstSts_trvl_desc').updateValueAndValidity();
    }
  }

  //industry type validation for proposer
  industryTypeValidate() {
    console.log('hiiiii', this.proposerDetailsForm.get('pr_indsTypeQuestion').value)
    if (this.proposerDetailsForm.get('pr_indsTypeQuestion').value === true) {
      this.showindustry = true;
      this.proposerDetailsForm.get('pr_indsType').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();
    }
    else {
      this.showindustry = false;
      this.proposerDetailsForm.get('pr_indsType').clearValidators();
      this.proposerDetailsForm.get('pr_indsType').setValue("");
      this.proposerDetailsForm.get('pr_indsType').updateValueAndValidity();
    }
  }

  showInvestiDesc: boolean = false;
  // Currently Investigated
  validateCurrentlyInvestigated() {
    console.log('hiiiii', this.proposerDetailsForm.get('pr_currentlyInvestigated').value)
    if (this.proposerDetailsForm.get('pr_currentlyInvestigated').value === true) {
      this.showInvestiDesc = true;
      this.proposerDetailsForm.get('pr_investigationDtls').setValidators(Validators.required);
      this.proposerDetailsForm.get('pr_investigationDtls').updateValueAndValidity();
    } else {
      this.showInvestiDesc = false;
      this.proposerDetailsForm.get('pr_investigationDtls').clearValidators();
      this.proposerDetailsForm.get('pr_investigationDtls').setValue("");
      this.proposerDetailsForm.get('pr_investigationDtls').updateValueAndValidity();
    }
  }

  //lifeassured other fields
  lifAssuredOtherShowField() {
    console.log("hiii therr");
    if (this.LifeDetailsForm.get('lf_mrtlSts').value === "696") {
      this.showspouse_lf = true;
    }
    else {
      this.showspouse_lf = false;
      this.LifeDetailsForm.get('lf_spouseName').setValue("");
      this.LifeDetailsForm.get('lf_spouseName').updateValueAndValidity();
    }
    if (this.LifeDetailsForm.get('lf_orgType').value === "NOT ANSWERED" || this.LifeDetailsForm.get('lf_org_selfemployed').value === "NOT ANSWERED") {
      this.showorgdesc_lf = true;
      this.LifeDetailsForm.get("lf_orgTypeDesc").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30)
      ]);
      this.LifeDetailsForm.get('lf_orgTypeDesc').updateValueAndValidity();
    }
    else {
      this.showorgdesc_lf = false;
      this.LifeDetailsForm.get('lf_orgTypeDesc').clearValidators();
      this.LifeDetailsForm.get('lf_orgTypeDesc').setValue("");
      this.LifeDetailsForm.get('lf_orgTypeDesc').updateValueAndValidity();
    }
    //toggle nationality
    if (this.LifeDetailsForm.get('lf_nationality').value === "Indian") {
      this.showresidential = true;
      this.showres_nonindian = false;
      this.LifeDetailsForm.get('lf_rstSts').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_rstSts_NIndian').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_NIndian').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_NIndian').updateValueAndValidity();

    }
    else if (this.LifeDetailsForm.get('lf_nationality').value === "Non indian") {
      this.showres_nonindian = true;
      this.showresidential = false;
      this.LifeDetailsForm.get('lf_rstSts_NIndian').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_NIndian').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_rstSts').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts').setValue("");
      this.LifeDetailsForm.get('lf_rstSts').updateValueAndValidity();

    }
    else {
      this.showresidential = false;
      this.showres_nonindian = false;
      this.LifeDetailsForm.get('lf_rstSts').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts').setValue("");
      this.LifeDetailsForm.get('lf_rstSts').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_NIndian').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_NIndian').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_NIndian').updateValueAndValidity();
    }
  }

  //residentail status validation for life assured
  residentailvalidatelifeassured() {
    //toggle residentiality status
    if (this.LifeDetailsForm.get("lf_rstSts").value === "NRI" || this.LifeDetailsForm.get('lf_rstSts_NIndian').value === "PIO" || this.LifeDetailsForm.get('lf_rstSts_NIndian').value === "Foreign National") {
      this.showNRI = true;
      this.LifeDetailsForm.get('lf_rstSts_nri').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_nri').setValue(false);
      this.LifeDetailsForm.get('lf_rstSts_nri').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_nri_nationlity').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_nri_nationlity').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_nri_country').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_nri_country').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin1_contry').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_tin1_contry').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin2_contry').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_tin2_contry').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').updateValueAndValidity();

      this.LifeDetailsForm.get("lf_rstSts_passport").setValidators([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(15)
      ]);
      this.LifeDetailsForm.get('lf_rstSts_passport').updateValueAndValidity();
      this.LifeDetailsForm.get('lf_rstSts_DOA').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_DOA').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOL').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_DOL').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOS').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_DOS').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOSM').setValidators(Validators.required);
      this.LifeDetailsForm.get('lf_rstSts_DOSM').updateValueAndValidity();

      this.LifeDetailsForm.get("lf_rstSts_purpse").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]);
      this.LifeDetailsForm.get('lf_rstSts_purpse').updateValueAndValidity();
      this.LifeDetailsForm.get("lf_rstSts_emp").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]);
      this.LifeDetailsForm.get('lf_rstSts_emp').updateValueAndValidity();
    } else {
      this.showNRI = false;
      this.LifeDetailsForm.get('lf_rstSts_nri').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_nri').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_nri').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_nri_nationlity').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_nri_nationlity').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_nri_nationlity').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_nri_country').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_nri_country').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_nri_country').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin1_contry').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_tin1_contry').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_tin1_contry').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin2_contry').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_tin2_contry').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_tin2_contry').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_passport').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_passport').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_passport').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOA').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_DOA').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_DOA').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOS').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_DOS').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_DOS').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOL').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_DOL').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_DOL').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_DOSM').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_DOSM').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_DOSM').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_purpse').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_purpse').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_purpse').updateValueAndValidity();

      this.LifeDetailsForm.get('lf_rstSts_emp').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_emp').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_emp').updateValueAndValidity();
    }
    if (this.LifeDetailsForm.get('lf_rstSts_travel').value === true) {
      this.showNRItraveldetails = true;
      this.LifeDetailsForm.get("lf_rstSts_trvl_desc").setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]);
      this.LifeDetailsForm.get('lf_rstSts_trvl_desc').updateValueAndValidity();
    }
    else {
      this.showNRItraveldetails = false;
      this.LifeDetailsForm.get('lf_rstSts_trvl_desc').clearValidators();
      this.LifeDetailsForm.get('lf_rstSts_trvl_desc').setValue("");
      this.LifeDetailsForm.get('lf_rstSts_trvl_desc').updateValueAndValidity();
    }
  }

  //nomine other fields
  NomineandINSshowField() {
    //mwpaopted
    if (this.MwpaDetailsForm.get('lf_mwpaOpted').value === true) {
      this.showbeneficerydetails = true;
      this.trusteedetails = true;
      this.showappontieedeatils = false;
      this.shownomineedetials = false;
      // this.MwpaDetailsForm.get("lf_br_frstNm").setValidators([
      //   Validators.required,
      //   Validators.minLength(1),
      //   Validators.maxLength(30)
      // ]);
      // this.MwpaDetailsForm.get('lf_br_frstNm').updateValueAndValidity();
      // this.MwpaDetailsForm.get("lf_br_lstNm").setValidators([
      //   Validators.required,
      //   Validators.minLength(1),
      //   Validators.maxLength(30)
      // ]);
      // this.MwpaDetailsForm.get('lf_br_lstNm').updateValueAndValidity();
      // this.MwpaDetailsForm.get('lf_br_dob').setValidators(Validators.required);
      // this.MwpaDetailsForm.get('lf_br_dob').updateValueAndValidity();
      // this.MwpaDetailsForm.get('lf_br_relationWithLa').setValidators(Validators.required);
      // this.MwpaDetailsForm.get('lf_br_relationWithLa').updateValueAndValidity();
      // this.MwpaDetailsForm.get('lf_br_share').setValidators(Validators.required);
      // this.MwpaDetailsForm.get('lf_br_share').updateValueAndValidity();
      this.benefiArray.controls.forEach(f => {
        f.get('frstNm').setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(30)]);
        f.get('frstNm').updateValueAndValidity();
        f.get('lstNm').setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(30)]);
        f.get('lstNm').updateValueAndValidity();
        f.get('relationship').setValidators(Validators.required);
        f.get('relationship').updateValueAndValidity();
        f.get('dob').setValidators(Validators.required);
        f.get('dob').updateValueAndValidity();
        f.get('shareOfBenefit').setValidators([Validators.required, Validators.max(this.maxShareAllowed)]);
        f.get('shareOfBenefit').updateValueAndValidity();
      });
      // this.MwpaDetailsForm.get('lf_br_Minor').setValidators(Validators.required);
      // this.MwpaDetailsForm.get('lf_br_Minor').updateValueAndValidity();
      this.MwpaDetailsForm.get("lf_tr_frstNm").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_tr_salutn').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_salutn').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_tr_frstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_tr_dob').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_dob').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_tr_relationWithLa').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_relationWithLa').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_tr_pincode').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_pincode').updateValueAndValidity();
      this.MwpaDetailsForm.get("lf_tr_address").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_tr_address').updateValueAndValidity();
      this.MwpaDetailsForm.get("lf_tr_city").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_tr_city').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_state').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_state').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_panNo').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_panNo').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_mobNo').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_mobNo').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_email').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_tr_email').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_nm_frstNm').clearValidators();
      this.MwpaDetailsForm.get('lf_nm_frstNm').setValue("");
      this.MwpaDetailsForm.get('lf_nm_frstNm').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_nm_lstNm').clearValidators();
      this.MwpaDetailsForm.get('lf_nm_lstNm').setValue("");
      this.MwpaDetailsForm.get('lf_nm_lstNm').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_nm_dob').clearValidators();
      this.MwpaDetailsForm.get('lf_nm_dob').setValue("");
      this.MwpaDetailsForm.get('lf_nm_dob').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_nm_gender').clearValidators();
      this.MwpaDetailsForm.get('lf_nm_gender').setValue("");
      this.MwpaDetailsForm.get('lf_nm_gender').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_nm_relationWithLa').clearValidators();
      this.MwpaDetailsForm.get('lf_nm_relationWithLa').setValue("");
      this.MwpaDetailsForm.get('lf_nm_relationWithLa').updateValueAndValidity();
    }
    else {
      this.shownomineedetials = true;
      this.showbeneficerydetails = false;
      this.trusteedetails = false;
      this.showappontieedeatils = false;
      this.MwpaDetailsForm.get('lf_tr_salutn').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_salutn').setValue("");
      this.MwpaDetailsForm.get('lf_tr_salutn').updateValueAndValidity();

      // this.MwpaDetailsForm.get('lf_br_frstNm').clearValidators();
      // this.MwpaDetailsForm.get('lf_br_frstNm').setValue("");
      // this.MwpaDetailsForm.get('lf_br_frstNm').updateValueAndValidity();

      // this.MwpaDetailsForm.get('lf_br_lstNm').clearValidators();
      // this.MwpaDetailsForm.get('lf_br_lstNm').setValue("");
      // this.MwpaDetailsForm.get('lf_br_lstNm').updateValueAndValidity();

      // this.MwpaDetailsForm.get('lf_br_relationWithLa').clearValidators();
      // this.MwpaDetailsForm.get('lf_br_relationWithLa').setValue("");
      // this.MwpaDetailsForm.get('lf_br_relationWithLa').updateValueAndValidity();

      // this.MwpaDetailsForm.get('lf_br_share').clearValidators();
      // this.MwpaDetailsForm.get('lf_br_share').setValue("");
      // this.MwpaDetailsForm.get('lf_br_share').updateValueAndValidity();

      this.benefiArray.controls.forEach(f => {
        f.get('frstNm').clearValidators();
        f.get('frstNm').setValue("");
        f.get('frstNm').updateValueAndValidity();
        f.get('lstNm').clearValidators();
        f.get('lstNm').setValue("");
        f.get('lstNm').updateValueAndValidity();
        f.get('relationship').clearValidators();
        f.get('relationship').setValue("");
        f.get('relationship').updateValueAndValidity();
        f.get('dob').clearValidators();
        f.get('dob').setValue("");
        f.get('dob').updateValueAndValidity();
        f.get('shareOfBenefit').clearValidators();
        f.get('shareOfBenefit').setValue("");
        f.get('shareOfBenefit').updateValueAndValidity();
      });

      // this.MwpaDetailsForm.get('lf_br_Minor').clearValidators();
      // this.MwpaDetailsForm.get('lf_br_Minor').setValue("");
      // this.MwpaDetailsForm.get('lf_br_Minor').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_frstNm').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_frstNm').setValue("");
      this.MwpaDetailsForm.get('lf_tr_frstNm').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_dob').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_dob').setValue("");
      this.MwpaDetailsForm.get('lf_tr_dob').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_relationWithLa').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_relationWithLa').setValue("");
      this.MwpaDetailsForm.get('lf_tr_relationWithLa').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_pincode').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_pincode').setValue("");
      this.MwpaDetailsForm.get('lf_tr_pincode').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_address').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_address').setValue("");
      this.MwpaDetailsForm.get('lf_tr_address').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_city').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_city').setValue("");
      this.MwpaDetailsForm.get('lf_tr_city').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_panNo').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_panNo').setValue("");
      this.MwpaDetailsForm.get('lf_tr_panNo').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_state').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_state').setValue("");
      this.MwpaDetailsForm.get('lf_tr_state').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_mobNo').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_mobNo').setValue("");
      this.MwpaDetailsForm.get('lf_tr_mobNo').updateValueAndValidity();

      this.MwpaDetailsForm.get('lf_tr_email').clearValidators();
      this.MwpaDetailsForm.get('lf_tr_email').setValue("");
      this.MwpaDetailsForm.get('lf_tr_email').updateValueAndValidity();

      this.MwpaDetailsForm.get("lf_nm_frstNm").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_nm_frstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get("lf_nm_lstNm").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_nm_lstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_nm_dob').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_nm_dob').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_nm_gender').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_nm_gender').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_nm_relationWithLa').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_nm_relationWithLa').updateValueAndValidity();
    }
  }

  //health other fields
  HealthOtherField(event) {
    console.log("hiiii", event);
    console.log("hiiii", event.target.attributes.formcontrolname.nodeValue);
    if (this.HealthDetailsForm.get('hl_tabacoo').value === "Yes") {
      this.showTobacooConsumedas = true;
      this.HealthDetailsForm.get('hl_consumption_period').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_consumption_period').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_quant_day').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_quant_day').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_tabaco_years').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_tabaco_years').updateValueAndValidity();
    } else {
      this.showTobacooConsumedas = false;
      this.HealthDetailsForm.get('hl_consumption_period').clearValidators();
      this.HealthDetailsForm.get('hl_consumption_period').setValue("");
      this.HealthDetailsForm.get('hl_consumption_period').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_quant_day').clearValidators();
      this.HealthDetailsForm.get('hl_quant_day').setValue("");
      this.HealthDetailsForm.get('hl_quant_day').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_tabaco_years').clearValidators();
      this.HealthDetailsForm.get('hl_tabaco_years').setValue("");
      this.HealthDetailsForm.get('hl_tabaco_years').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_alcohol').value === "Yes") {
      this.showalcoholas = true;
      this.HealthDetailsForm.get('hl_alch_period').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_alch_period').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_alch_day').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_alch_day').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_alch_years').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_alch_years').updateValueAndValidity();
    } else {
      this.showalcoholas = false;
      this.HealthDetailsForm.get('hl_alch_period').clearValidators();
      this.HealthDetailsForm.get('hl_alch_period').setValue("");
      this.HealthDetailsForm.get('hl_alch_period').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_alch_day').clearValidators();
      this.HealthDetailsForm.get('hl_alch_day').setValue("");
      this.HealthDetailsForm.get('hl_alch_day').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_alch_years').clearValidators();
      this.HealthDetailsForm.get('hl_alch_years').setValue("");
      this.HealthDetailsForm.get('hl_alch_years').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_chemical_exposure').value === "Yes") {
      this.showchemicalexposure = true;
      this.HealthDetailsForm.get('hl_remark_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_remark_descrptn').updateValueAndValidity();
    } else {
      this.showchemicalexposure = false;
      this.HealthDetailsForm.get('hl_remark_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_remark_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_remark_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_army_emply').value === "Yes") {
      this.showarmydescp = true;
      this.HealthDetailsForm.get('hl_army_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_army_descrptn').updateValueAndValidity();
    } else {
      this.showarmydescp = false;
      this.HealthDetailsForm.get('hl_army_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_army_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_army_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_lost_wgts').value === "Yes") {
      this.sholostwgtsdescp = true;
      this.HealthDetailsForm.get('hl_lostwgts_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_lostwgts_descrptn').updateValueAndValidity();
    } else {
      this.sholostwgtsdescp = false;
      this.HealthDetailsForm.get('hl_lostwgts_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_lostwgts_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_lostwgts_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_fmly_illnes').value === "Yes") {
      this.showillnesdescp = true;
      this.HealthDetailsForm.get('hl_fmlyillnes_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_fmlyillnes_descrptn').updateValueAndValidity();
    } else {
      this.showillnesdescp = false;
      this.HealthDetailsForm.get('hl_fmlyillnes_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_fmlyillnes_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_fmlyillnes_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_surgery').value === "Yes") {
      this.showsurgerydescp = true;
      this.HealthDetailsForm.get('hl_surgery_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_surgery_descrptn').updateValueAndValidity();
    } else {
      this.showsurgerydescp = false;
      this.HealthDetailsForm.get('hl_surgery_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_surgery_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_surgery_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_med_suffering').value === "Yes") {
      this.showmedsuffering = true;
      this.HealthDetailsForm.get('hl_medsuffrng_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medsuffrng_descrptn').updateValueAndValidity();
    } else {
      this.showmedsuffering = false;
      this.HealthDetailsForm.get('hl_medsuffrng_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_medsuffrng_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_medsuffrng_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_declartion_form').value === "Yes") {
      this.showDeclartionques = true;
      this.HealthDetailsForm.get('hl_medi_condn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medi_condn').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_medical_diagnosis').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medical_diagnosis').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_medical_treatmt').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medical_treatmt').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_med_currntstg').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_med_currntstg').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_medical_detls').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medical_detls').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_medical_testundgne').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medical_testundgne').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_medical_othrdtls').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medical_othrdtls').updateValueAndValidity();
    }
    else {
      this.showDeclartionques = false;
      this.HealthDetailsForm.get('hl_medi_condn').clearValidators();
      this.HealthDetailsForm.get('hl_medi_condn').setValue("");
      this.HealthDetailsForm.get('hl_medi_condn').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_medical_diagnosis').clearValidators();
      this.HealthDetailsForm.get('hl_medical_diagnosis').setValue("");
      this.HealthDetailsForm.get('hl_medical_diagnosis').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_medical_treatmt').clearValidators();
      this.HealthDetailsForm.get('hl_medical_treatmt').setValue("");
      this.HealthDetailsForm.get('hl_medical_treatmt').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_med_currntstg').clearValidators();
      this.HealthDetailsForm.get('hl_med_currntstg').setValue("");
      this.HealthDetailsForm.get('hl_med_currntstg').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_medical_detls').clearValidators();
      this.HealthDetailsForm.get('hl_medical_detls').setValue("");
      this.HealthDetailsForm.get('hl_medical_detls').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_medical_testundgne').clearValidators();
      this.HealthDetailsForm.get('hl_medical_testundgne').setValue("");
      this.HealthDetailsForm.get('hl_medical_testundgne').updateValueAndValidity();

      this.HealthDetailsForm.get('hl_medical_othrdtls').clearValidators();
      this.HealthDetailsForm.get('hl_medical_othrdtls').setValue("");
      this.HealthDetailsForm.get('hl_medical_othrdtls').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_med_handicap').value === "Yes") {
      this.showmedhandicap = true;
      this.HealthDetailsForm.get('hl_medhandicap_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medhandicap_descrptn').updateValueAndValidity();
    }
    else {
      this.showmedhandicap = false;
      this.HealthDetailsForm.get('hl_medhandicap_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_medhandicap_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_medhandicap_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_med_injury').value === "Yes") {
      this.showmedinjury = true;
      this.HealthDetailsForm.get('hl_medinjury_descrptn').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_medinjury_descrptn').updateValueAndValidity();
    }
    else {
      this.showmedinjury = false;
      this.HealthDetailsForm.get('hl_medinjury_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_medinjury_descrptn').setValue("");
      this.HealthDetailsForm.get('hl_medinjury_descrptn').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get('hl_pregant').value === "Yes") {
      this.showpregntweeks = true;
      this.HealthDetailsForm.get('hl_pregnant_weeks').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_pregnant_weeks').updateValueAndValidity();
    }
    else {
      this.showpregntweeks = false;
      this.HealthDetailsForm.get('hl_pregnant_weeks').clearValidators();
      this.HealthDetailsForm.get('hl_pregnant_weeks').setValue("");
      this.HealthDetailsForm.get('hl_pregnant_weeks').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_everTested").value === "Yes") {
      this.showCovidQue6Sub = true;
      this.HealthDetailsForm.get("hl_covid_fullyRecovered").setValidators(Validators.required);
    } else {
      this.showCovidQue6Sub = false;
      this.HealthDetailsForm.get("hl_covid_fullyRecovered").clearValidators();
      this.HealthDetailsForm.get("hl_covid_fullyRecovered").updateValueAndValidity();
      this.showCovidQue6SubReflex = false;
      this.HealthDetailsForm.get("hl_covid_dateOfDiagnosis").clearValidators();
      this.HealthDetailsForm.get("hl_covid_dateOfDiagnosis").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_dateOfRecovery").clearValidators();
      this.HealthDetailsForm.get("hl_covid_dateOfRecovery").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_hospital").clearValidators();
      this.HealthDetailsForm.get("hl_covid_hospital").updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_fullyRecovered").value === "Yes") {
      this.showCovidQue6SubReflex = true;
      this.HealthDetailsForm.get("hl_covid_dateOfDiagnosis").setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_dateOfRecovery").setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_hospital").setValidators(Validators.required);
    } else {
      this.showCovidQue6SubReflex = false;
      this.HealthDetailsForm.get("hl_covid_dateOfDiagnosis").clearValidators();
      this.HealthDetailsForm.get("hl_covid_dateOfDiagnosis").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_dateOfRecovery").clearValidators();
      this.HealthDetailsForm.get("hl_covid_dateOfRecovery").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_hospital").clearValidators();
      this.HealthDetailsForm.get("hl_covid_hospital").updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_travel").value === "Yes") {
      this.showCovidQue10Sub = true;
      this.HealthDetailsForm.get("hl_covid_travelCountry").setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_arrivalDt").setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_leavingDt").setValidators(Validators.required);
    } else {
      this.showCovidQue10Sub = false;
      this.HealthDetailsForm.get("hl_covid_travelCountry").clearValidators();
      this.HealthDetailsForm.get("hl_covid_travelCountry").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_arrivalDt").clearValidators();
      this.HealthDetailsForm.get("hl_covid_arrivalDt").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_leavingDt").clearValidators();
      this.HealthDetailsForm.get("hl_covid_leavingDt").updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_vaccineSideEffect").value === "Yes") {
      this.showCovidQue12Sub = true;
      // this.HealthDetailsForm.get("hl_covid_vaccineSideEffectHospital").setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_vaccineSideEffectDetails").setValidators(Validators.required);
    } else {
      this.showCovidQue12Sub = false;
      // this.HealthDetailsForm.get("hl_covid_vaccineSideEffectHospital").clearValidators();
      this.HealthDetailsForm.get("hl_covid_vaccineSideEffectDetails").clearValidators();
      this.HealthDetailsForm.get("hl_covid_vaccineSideEffectDetails").updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_isVaccinated").value === "Yes") {
      this.showCovidQue30SubReflex = true;
      this.HealthDetailsForm.get('hl_covid_1stDoseDate').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_1stDoseName').setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_isVaccinated2ndDose").setValidators(Validators.required);
      this.HealthDetailsForm.get("hl_covid_vaccineSideEffect").setValidators(Validators.required);
    } else {
      this.showCovidQue30SubReflex = false;
      this.HealthDetailsForm.get('hl_covid_1stDoseDate').clearValidators();
      this.HealthDetailsForm.get('hl_covid_1stDoseDate').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_1stDoseName').clearValidators();
      this.HealthDetailsForm.get('hl_covid_1stDoseName').updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_isVaccinated2ndDose").clearValidators();
      this.HealthDetailsForm.get("hl_covid_isVaccinated2ndDose").updateValueAndValidity();
      this.HealthDetailsForm.get("hl_covid_vaccineSideEffect").clearValidators();
      this.HealthDetailsForm.get("hl_covid_vaccineSideEffect").updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_isVaccinated2ndDose").value === "Yes") {
      this.showCovidQue33SubReflex = true;
      this.HealthDetailsForm.get('hl_covid_2ndDoseDate').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_2ndDoseName').setValidators(Validators.required);
    } else {
      this.showCovidQue33SubReflex = false;
      this.HealthDetailsForm.get('hl_covid_2ndDoseDate').clearValidators();
      this.HealthDetailsForm.get('hl_covid_2ndDoseDate').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_2ndDoseName').clearValidators();
      this.HealthDetailsForm.get('hl_covid_2ndDoseName').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_outsideInd").value === "Yes") {
      this.showCovidQue38Sub = true;
      this.HealthDetailsForm.get('hl_covid_outsideIndCountry').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_outsideIndCity').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_outsideIndDateOfTarvel').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_outsideIndIndentedMonth').setValidators(Validators.required);
    } else {
      this.showCovidQue38Sub = false;
      this.HealthDetailsForm.get('hl_covid_outsideIndCountry').clearValidators();
      this.HealthDetailsForm.get('hl_covid_outsideIndCountry').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_outsideIndCity').clearValidators();
      this.HealthDetailsForm.get('hl_covid_outsideIndCity').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_outsideIndDateOfTarvel').clearValidators();
      this.HealthDetailsForm.get('hl_covid_outsideIndDateOfTarvel').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_outsideIndIndentedMonth').clearValidators();
      this.HealthDetailsForm.get('hl_covid_outsideIndIndentedMonth').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_travel14").value === "Yes") {
      this.showCovidQue43Sub = true;
      this.HealthDetailsForm.get('hl_covid_travel14Country').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_travel14City').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_travel14DateArrived').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_travel14DateDeptd').setValidators(Validators.required);
    } else {
      this.showCovidQue43Sub = false;
      this.HealthDetailsForm.get('hl_covid_travel14Country').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel14Country').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_travel14City').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel14City').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_travel14DateArrived').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel14DateArrived').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_travel14DateDeptd').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel14DateDeptd').updateValueAndValidity();
    }

    if (this.HealthDetailsForm.get("hl_covid_travel3M").value === "Yes") {
      this.showCovidQue56Sub = true;
      console.log("health details form controls", this.HealthDetailsForm.controls)
      this.HealthDetailsForm.get('hl_covid_travel3MCountry').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_travel3MCity').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_travel3MDateOfTarvel').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_covid_travel3MIndentedMonth').setValidators(Validators.required);
    } else {
      console.log("health details form controls", this.HealthDetailsForm.controls)
      this.showCovidQue56Sub = false;
      this.HealthDetailsForm.get('hl_covid_travel3MCountry').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel3MCountry').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_travel3MCity').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel3MCity').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_travel3MDateOfTarvel').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel3MDateOfTarvel').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_covid_travel3MIndentedMonth').clearValidators();
      this.HealthDetailsForm.get('hl_covid_travel3MIndentedMonth').updateValueAndValidity();
    }
  }

  showCovidQue6Sub: boolean = false;
  showCovidQue6SubReflex: boolean = false;
  showCovidQue10Sub: boolean = false;
  showCovidQue12Sub: boolean = false;
  // showCovidQue6SubQue: boolean = false;

  //uncheck event
  unCheckAll(event) {
    console.log(event.detail.checked, 'clicked event')
    if (event.detail.checked == true) {
      this.HealthDetailsForm.get('hl_answer1').setValue(false);
      this.HealthDetailsForm.get('hl_answer2').setValue(false);
      this.HealthDetailsForm.get('hl_answer3').setValue(false);
      this.HealthDetailsForm.get('hl_answer4').setValue(false);
      this.HealthDetailsForm.get('hl_answer5').setValue(false);
      this.HealthDetailsForm.get('hl_answer6').setValue(false);
      this.HealthDetailsForm.get('hl_answer7').setValue(false);
      this.HealthDetailsForm.get('hl_answer8').setValue(false);
      this.HealthDetailsForm.get('hl_answer9').setValue(false);
      this.HealthDetailsForm.get('hl_answer10').setValue(false);
      this.HealthDetailsForm.get('hl_answer11').setValue(false);
      this.HealthDetailsForm.get('hl_answer12').setValue(false);
      this.HealthDetailsForm.get('hl_answer13').setValue(false);
      this.HealthDetailsForm.get('hl_answer14').setValue(false);
    }
    else {
      this.HealthDetailsForm.get('hl_answer1').value == "";
      this.HealthDetailsForm.get('hl_answer2').value == "";
      this.HealthDetailsForm.get('hl_answer3').value == "";
      this.HealthDetailsForm.get('hl_answer4').value == "";
      this.HealthDetailsForm.get('hl_answer5').value == "";
      this.HealthDetailsForm.get('hl_answer6').value == "";
      this.HealthDetailsForm.get('hl_answer7').value == "";
      this.HealthDetailsForm.get('hl_answer8').value == "";
      this.HealthDetailsForm.get('hl_answer9').value == "";
      this.HealthDetailsForm.get('hl_answer10').value == "";
      this.HealthDetailsForm.get('hl_answer11').value == "";
      this.HealthDetailsForm.get('hl_answer12').value == "";
      this.HealthDetailsForm.get('hl_answer13').value == "";
      this.HealthDetailsForm.get('hl_answer14').value == "";
    }
  }

  uncheckAnswer(event) {
    if (event.detail.checked == true) {
      this.HealthDetailsForm.get('hl_answer15').setValue(false);
      this.hlslecetdescrptn = true;
      this.showhealthdeclatnform = true;
      this.HealthDetailsForm.get('hl_declartion_form').setValidators(Validators.required);
      this.HealthDetailsForm.get('hl_declartion_form').updateValueAndValidity();
      this.HealthDetailsForm.get("hl_slecet_descrptn").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.HealthDetailsForm.get('hl_slecet_descrptn').updateValueAndValidity();
    }
    else {
      this.HealthDetailsForm.get('hl_answer15').setValue(true);
      this.hlslecetdescrptn = false;
      this.showhealthdeclatnform = false;
      this.HealthDetailsForm.get('hl_declartion_form').clearValidators();
      this.HealthDetailsForm.get('hl_declartion_form').setValue("");
      this.HealthDetailsForm.get('hl_declartion_form').updateValueAndValidity();
      this.HealthDetailsForm.get('hl_slecet_descrptn').clearValidators();
      this.HealthDetailsForm.get('hl_slecet_descrptn').updateValueAndValidity();
    }

  }

  //uploaded others fields
  uploadDocument(event?) {
    console.log("hii im called");
    if (this.UploadDocumentsDetailsForm.get("up_itPrf").value === "pancard") {
      this.showpan = true;
      this.UploadDocumentsDetailsForm.get("up_panNo").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.UploadDocumentsDetailsForm.get('up_panNo').updateValueAndValidity();
    }
    else {
      this.showpan = false;
      this.UploadDocumentsDetailsForm.get('up_panNo').setValue("");
      this.UploadDocumentsDetailsForm.get('up_panNo').clearValidators();
      this.UploadDocumentsDetailsForm.get('up_panNo').updateValueAndValidity();
    }
  }

  //payment other fields
  paymentDocument() {
    if (this.paymentDocumentsForm.get("pay_ele_ins").value === "Yes") {
      this.showEIAaccnumber = true;
      this.paymentDocumentsForm.get("pay_eia_num").setValidators(Validators.required);
      this.paymentDocumentsForm.get("pay_eia_num").updateValueAndValidity();
    }
    else {
      this.showEIAaccnumber = false;
      this.paymentDocumentsForm.get("pay_eia_num").clearValidators();
      this.paymentDocumentsForm.get("pay_eia_num").setValue("");
      this.paymentDocumentsForm.get("pay_eia_num").updateValueAndValidity();
    }
  }

  //same as permanent address
  sameAddressChanged1(event) {
    console.log(event.detail.checked, 'address')
    let pro_address1 = this.proposerDetailsForm.get('pr_line1');
    let pro_address2 = this.proposerDetailsForm.get('pr_line2');
    let pro_address3 = this.proposerDetailsForm.get('pr_line3');
    let pro_landmark = this.proposerDetailsForm.get('pr_landmark');
    let pro_city = this.proposerDetailsForm.get('pr_city');
    let pro_pincode = this.proposerDetailsForm.get('pr_pincode');
    let pro_state = this.proposerDetailsForm.get('pr_state');
    let pro_country = this.proposerDetailsForm.get('pr_country');

    let pro_currnt_address1 = this.proposerDetailsForm.get("pr_currnt_line1");
    let pro_currnt_address2 = this.proposerDetailsForm.get("pr_currnt_line2");
    let pro_currnt_address3 = this.proposerDetailsForm.get("pr_currnt_line3");
    let pro_currnt_landmark = this.proposerDetailsForm.get("pr_currnt_landmark");
    let pro_currnt_city = this.proposerDetailsForm.get("pr_currnt_city");
    let pro_currnt_pincode = this.proposerDetailsForm.get("pr_currnt_pincode");
    let pro_currnt_state = this.proposerDetailsForm.get("pr_current_state");
    let pro_currnt_country = this.proposerDetailsForm.get("pr_current_country");

    if (event.detail.checked === true) {
      pro_currnt_address1.setValue(pro_address1.value);
      pro_currnt_address2.setValue(pro_address2.value);
      pro_currnt_address3.setValue(pro_address3.value);
      pro_currnt_landmark.setValue(pro_landmark.value);
      pro_currnt_city.setValue(pro_city.value);
      pro_currnt_pincode.setValue(pro_pincode.value);
      pro_currnt_state.setValue(pro_state.value);
      pro_currnt_country.setValue(pro_country.value);
    }
    else {
      pro_currnt_address1.setValue("");
      pro_currnt_address2.setValue("");
      pro_currnt_address3.setValue("");
      pro_currnt_landmark.setValue("");
      pro_currnt_city.setValue("");
      pro_currnt_pincode.setValue("");
      pro_currnt_state.setValue("");
      pro_currnt_country.setValue("");
    }

  }

  validateDate(event) {
    console.log(event);
    const today = new Date();
    let dobInput = new Date(`${event.detail.value}`);
    this.lf_nm_dob = today.getFullYear() - dobInput.getFullYear();
    const m = today.getMonth() - dobInput.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobInput.getDate())) {
      this.lf_nm_dob--;
      // this.lifAssuredOtherShowField(event);
    }
    else {
      console.log('hii')
    }
    if (this.lf_nm_dob-- <= 18) {
      this.NomineandINSshowField();
      this.showappontieedeatils = true;
      this.showbeneficerydetails = false;
      this.trusteedetails = false;
      this.MwpaDetailsForm.get("lf_ap_frstNm").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_ap_frstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get("lf_ap_lstNm").setValidators([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
      ]);
      this.MwpaDetailsForm.get('lf_ap_lstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_gender').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_ap_gender').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_dob').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_ap_dob').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_relationWithLa').setValidators(Validators.required);
      this.MwpaDetailsForm.get('lf_ap_relationWithLa').updateValueAndValidity();
    }
    else {
      this.showappontieedeatils = false;
      this.showbeneficerydetails = false;
      this.trusteedetails = false;
      this.MwpaDetailsForm.get('lf_ap_frstNm').setValue("");
      this.MwpaDetailsForm.get('lf_ap_frstNm').clearValidators();
      this.MwpaDetailsForm.get('lf_ap_frstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_lstNm').setValue("");
      this.MwpaDetailsForm.get('lf_ap_lstNm').clearValidators();
      this.MwpaDetailsForm.get('lf_ap_lstNm').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_gender').setValue("");
      this.MwpaDetailsForm.get('lf_ap_gender').clearValidators();
      this.MwpaDetailsForm.get('lf_ap_gender').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_dob').setValue("");
      this.MwpaDetailsForm.get('lf_ap_dob').clearValidators();
      this.MwpaDetailsForm.get('lf_ap_dob').updateValueAndValidity();
      this.MwpaDetailsForm.get('lf_ap_relationWithLa').setValue("");
      this.MwpaDetailsForm.get('lf_ap_relationWithLa').clearValidators();
      this.MwpaDetailsForm.get('lf_ap_relationWithLa').updateValueAndValidity();
    }
    console.log('dob input', dobInput);
    console.log('age', this.lf_nm_dob);
  }

  //back button toogle functions
  backtonominee() {
    if (this.dependflagResponse.dependentFlag === "Y") {
      this.showProposerForm1 = true;
      this.showNomineeandIns = false;
      this.showLifeassuredForm = false;
      this.showHealthDeatilsForm = false;
      this.showUploadDetailsForm = false;
      this.showpaymentDocumentForm = false;
      this.showSubmitAPIdiv = false;
      this.showCongratulations = false;
      this.showErrorDiv = false;
      this.hidebackbtn = false;
      this.proposerFilled = "section-btn active-section-btn";
      this.lifeAssuredFilled = "section-btn";
      this.healthDetailsFilled = "section-btn";
      this.uploadDocumentsFilled = "section-btn";
      this.EIADetailsfilled = "section-btn";
    } else {
      this.showNomineeandIns = true;
      this.showLifeassuredForm = false;
      this.showHealthDeatilsForm = false;
      this.showUploadDetailsForm = false;
      this.showpaymentDocumentForm = false;
      this.showProposerForm1 = false;
      this.showSubmitAPIdiv = false;
      this.showCongratulations = false;
      this.showErrorDiv = false;
      this.hidebackbtn = false;
      this.proposerFilled = "section-btn active-section-btn";
      this.lifeAssuredFilled = "section-btn";
      this.healthDetailsFilled = "section-btn";
      this.uploadDocumentsFilled = "section-btn";
      this.EIADetailsfilled = "section-btn";
    }
  }

  backtoProposer() {
    this.showProposerForm1 = true;
    this.showNomineeandIns = false;
    this.showLifeassuredForm = false;
    this.showHealthDeatilsForm = false;
    this.showUploadDetailsForm = false;
    this.showpaymentDocumentForm = false;
    this.showSubmitAPIdiv = false;
    this.showCongratulations = false;
    this.showErrorDiv = false;
    this.hidebackbtn = true;
    this.proposerFilled = "section-btn active-section-btn";
    this.lifeAssuredFilled = "section-btn";
    this.healthDetailsFilled = "section-btn";
    this.uploadDocumentsFilled = "section-btn";
    this.EIADetailsfilled = "section-btn";
  }

  backform() {
    if (this.dependflagResponse.dependentFlag === "Y") {
      this.showLifeassuredForm = true;
      this.showProposerForm1 = false;
      this.showNomineeandIns = false;
      this.showHealthDeatilsForm = false;
      this.showUploadDetailsForm = false;
      this.showpaymentDocumentForm = false;
      this.showSubmitAPIdiv = false;
      this.showCongratulations = false;
      this.showErrorDiv = false;
      this.hidebackbtn = false;
      this.proposerFilled = "section-btn section-done-btn";
      this.lifeAssuredFilled = "section-btn active-section-btn";
      this.healthDetailsFilled = "section-btn";
      this.uploadDocumentsFilled = "section-btn";
      this.EIADetailsfilled = "section-btn";
    }
    else {
      this.showLifeassuredForm = false;
      this.showProposerForm1 = false;
      this.showNomineeandIns = true;
      this.showHealthDeatilsForm = false;
      this.showUploadDetailsForm = false;
      this.showpaymentDocumentForm = false;
      this.showSubmitAPIdiv = false;
      this.showCongratulations = false;
      this.showErrorDiv = false;
      this.hidebackbtn = false;
      this.proposerFilled = "section-btn active-section-btn";
      this.lifeAssuredFilled = "section-btn";
      this.healthDetailsFilled = "section-btn";
      this.uploadDocumentsFilled = "section-btn";
      this.EIADetailsfilled = "section-btn";
    }

  }

  backtoHealthdetails() {
    this.showHealthDeatilsForm = true;
    this.showLifeassuredForm = false;
    this.showNomineeandIns = false;
    this.showUploadDetailsForm = false;
    this.showpaymentDocumentForm = false;
    this.showProposerForm1 = false;
    this.showSubmitAPIdiv = false;
    this.showCongratulations = false;
    this.showErrorDiv = false;
    this.hidebackbtn = false;
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn active-section-btn";
    this.uploadDocumentsFilled = "section-btn";
    this.EIADetailsfilled = "section-btn";
  }

  backtoUploadDocuments() {
    this.hidebackbtn = false;
    this.showUploadDetailsForm = true;
    this.showpaymentDocumentForm = false;
    this.showHealthDeatilsForm = false;
    this.showLifeassuredForm = false;
    this.showNomineeandIns = false;
    this.showSubmitAPIdiv = false;
    this.showCongratulations = false;
    this.showErrorDiv = false;
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn active-section-btn";
    this.EIADetailsfilled = "section-btn";
  }

  backToPaymentForm() {
    this.hidebackbtn = false;
    this.showSegmentBtns = true;
    this.showUploadDetailsForm = false;
    this.showpaymentDocumentForm = true;
    this.showHealthDeatilsForm = false;
    this.showLifeassuredForm = false;
    this.showNomineeandIns = false;
    this.showSubmitAPIdiv = false;
    this.showCongratulations = false;
    this.showErrorDiv = false;
    this.showOtpVerify = false;
    this.showOtpInput = false;
    this.disableOtpInput = false;
    this.prPhoneNumberOtp = "";
  }


  nameoforganisationtogle(event) {
    if (event.organizationName === "Others") {
      this.shownameoforgansdecrptn = true;
    }
    else {
      this.shownameoforgansdecrptn = false;
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('pr_nameOfOrgdecstn').updateValueAndValidity();
    }
  }

  nameoforganisationtoglelf(event) {
    if (event.organizationName === "Others") {
      this.shownameoforgansdecrptn_lf = true;
    }
    else {
      this.shownameoforgansdecrptn_lf = false;
      this.LifeDetailsForm.get('lf_nameOfOrgdecstn').setValue("");
      this.proposerDetailsForm.get('lf_nameOfOrgdecstn').updateValueAndValidity();
    }
  }

  //constuction of form object
  submitProposalDetailsForm() {
    console.log(this.proposerDetailsForm.get('pr_nameOfOrg').value, 'yyyyy')
    console.log("tobaaaaaaaaaaaaaaccccccccccccccoooooooooooooooo", this.upgradedQuoteResponseObj.tobacco);
    if (this.upgradedQuoteResponseObj.tobacco === 0) {
      this.HealthDetailsForm.get("hl_tabacoo").setValue('No');
      this.showTobacooConsumedas = false;
    } else if (this.upgradedQuoteResponseObj.tobacco === 1) {
      this.HealthDetailsForm.get("hl_tabacoo").setValue('Yes')
      this.showTobacooConsumedas = true;
    }
    this.checkProgress();
    let orgntypeselection;
    let NameOfOrganistn;
    let NameOfOrganistndecp;
    let MyProfessionValue;
    let industypequestnvalue;
    let nriUSValue;
    let organistntypedescptn;
    let RelationshipwithLa = this.dependflagResponse.relationWithLa;

    console.log(RelationshipwithLa, 'relationnnnnnnnnnnn');

    if (
      // this.proposerDetailsForm.get('pr_occ').value === "SEDO" ||
      // this.proposerDetailsForm.get('pr_occ').value === "SEAR" ||
      this.proposerDetailsForm.get('pr_occ').value === "SEBU" ||
      // this.proposerDetailsForm.get('pr_occ').value === "SECO" ||
      // this.proposerDetailsForm.get('pr_occ').value === "SELA" ||
      this.proposerDetailsForm.get('pr_occ').value === "SEOT") {
      NameOfOrganistn = "Others";
      NameOfOrganistndecp = "Others";
      orgntypeselection = "NOT ANSWERED";
      organistntypedescptn = "Others"
    }
    else {
      NameOfOrganistn = this.proposerDetailsForm.get('pr_nameOfOrg').value.organizationName;
      NameOfOrganistndecp = this.proposerDetailsForm.get('pr_nameOfOrgdecstn').value;
      orgntypeselection = this.proposerDetailsForm.get('pr_org_selfemployed').value;
      organistntypedescptn = this.proposerDetailsForm.get('pr_orgTypeDesc').value
    }
    if (this.proposerDetailsForm.get('pr_occ').value === "BSEM") {
      orgntypeselection = this.proposerDetailsForm.get('pr_org_selfemployed').value;
      NameOfOrganistn = "Others"
      NameOfOrganistndecp = this.proposerDetailsForm.get('pr_nameOfOrgdecstn').value;
      organistntypedescptn = this.proposerDetailsForm.get('pr_orgTypeDesc').value
    }
    if (this.proposerDetailsForm.get('pr_occ').value === "SPVT" ||
      this.proposerDetailsForm.get('pr_occ').value === "SPRO") {
      orgntypeselection = this.proposerDetailsForm.get('pr_orgType').value;
    }

    if (this.proposerDetailsForm.get('pr_occ').value === "SELA") {
      MyProfessionValue = "Lawyer"
    }
    else if (this.proposerDetailsForm.get('pr_occ').value === "SECA") {
      MyProfessionValue = "CA"
    } else if (this.proposerDetailsForm.get('pr_occ').value === "SEDO") {
      MyProfessionValue = "Doctor"
    } else if (this.proposerDetailsForm.get('pr_occ').value === "SEAR") {
      MyProfessionValue = ""
    }
    else {
      MyProfessionValue = this.proposerDetailsForm.get('pr_myprof').value
    }
    if (this.proposerDetailsForm.get('pr_indsTypeQuestion').value === true) {
      industypequestnvalue = "Yes"
    } else if (this.proposerDetailsForm.get('pr_indsTypeQuestion').value === false) {
      industypequestnvalue = "No"
    } else {
      industypequestnvalue = "";
    }

    if (this.proposerDetailsForm.get('pr_rstSts_nri').value === true) {
      nriUSValue = "Yes"
    } else if (this.proposerDetailsForm.get('pr_rstSts_nri').value === false) {
      nriUSValue = "No"
    } else {
      nriUSValue = "";
    }
    // if(this.proposerDetailsForm.get('pr_nameOfOrg').value.organizationName === "Others"){
    //   NameOfOrganistndecp = this.proposerDetailsForm.get('pr_nameOfOrgdecstn').value;
    // }
    // console.log(NameOfOrganistn, NameOfOrganistndecp,'nameeeeoffforgggg');
    this.proposal_data = {
      "proposerInfos": {
        "frstNm": this.titlecasePipe.transform(this.proposerDetailsForm.get("pr_frstNm").value).trim(),
        "lstNm": this.titlecasePipe.transform(this.proposerDetailsForm.get("pr_lstNm").value).trim(),
        "mrtlSts": this.proposerDetailsForm.get('pr_mrtlSts').value,
        "dob": this._datePipe.transform(this.proposerDetailsForm.get('pr_dob').value, 'dd-MMMM-yyyy'),
        // "dob": this._datePipe.transform(this.dateOfBirth, 'dd-MMMM-yyyy') ? this._datePipe.transform(this.dateOfBirth, 'dd-MMMM-yyyy') : "",
        "gender": this.proposerDetailsForm.get("pr_gender").value,
        "isStaff": "0",
        // "mobNo": this.userObj.phoneNumber,
        "mobNo": this.userObj.phoneNumber,
        "orgType": this.uppercasePipe.transform(orgntypeselection) ? this.uppercasePipe.transform(orgntypeselection) : "",
        "orgTypeDesc": organistntypedescptn ? organistntypedescptn.trim() : "",
        "relationWithLa": RelationshipwithLa,
        "sharePortfolio": this.proposerDetailsForm.get('pr_sharePortfolio').value ? "Yes" : "No",
        "desig": "",
        "fathersName": this.titlecasePipe.transform(this.proposerDetailsForm.get('pr_fatherName').value).trim(),
        "mothersName": this.titlecasePipe.transform(this.proposerDetailsForm.get('pr_motherName').value).trim(),
        "spouseName": this.titlecasePipe.transform(this.proposerDetailsForm.get('pr_spouseName').value).trim(),
        "ckycNumber": "",
        "kycDoc": "",
        "comunctnAddress": {
          "pincode": this.proposerDetailsForm.get('pr_pincode').value,
          "landmark": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_landmark').value).trim(),
          "state": this.proposerDetailsForm.get('pr_state').value,
          "line1": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_line1').value).trim(),
          "line3": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_line3').value).trim(),
          "city": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_city').value).trim(),
          "country": this.proposerDetailsForm.get('pr_country').value,
          "line2": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_line2').value).trim(),
        },
        "nri": {
          "passportNo": this.proposerDetailsForm.get('pr_rstSts_passport').value,
          "dateOfArrivingIndia": this._datePipe.transform(this.proposerDetailsForm.get('pr_rstSts_DOA').value, 'MM/dd/yyyy') ? this._datePipe.transform(this.proposerDetailsForm.get('pr_rstSts_DOA').value, 'MM/dd/yyyy') : "",
          "dateOfLeavingIndia": this._datePipe.transform(this.proposerDetailsForm.get('pr_rstSts_DOL').value, 'MM/dd/yyyy') ? this._datePipe.transform(this.proposerDetailsForm.get('pr_rstSts_DOL').value, 'MM/dd/yyyy') : "",
          "durationOfStayInYear": this.proposerDetailsForm.get('pr_rstSts_DOS').value,
          "durationOfStayInMonth": this.proposerDetailsForm.get('pr_rstSts_DOSM').value,
          "nameOfEmployer": this.proposerDetailsForm.get('pr_rstSts_emp').value,
          "travelDetails": this.proposerDetailsForm.get('pr_rstSts_trvl_desc').value,
          "bankType": this.proposerDetailsForm.get('pr_rstSts_baccount').value,
          "countryOfResidence": this.proposerDetailsForm.get('pr_rstSts_nri_country').value,
          "nriTINIssuingCountry": this.proposerDetailsForm.get('pr_rstSts_tin1_contry').value,
          "tinNum": this.proposerDetailsForm.get('pr_rstSts_tin1_pan1').value,
          "tinNum2": this.proposerDetailsForm.get('pr_rstSts_tin2_pan2').value,
          "tinNum3": "",
          "nriBirthCountry": "",
          "placeOfBirthNRI": "",
          "countryOfResidence2": this.proposerDetailsForm.get('pr_rstSts_tin2_contry').value,
          "countryOfResidence3": "",
          "nriOtherResCountry": "",
          "countryOfNationality": this.proposerDetailsForm.get('pr_rstSts_nri_nationlity').value,
          "nriTaxResidentUS": nriUSValue,
          "purposeOfStay": this.proposerDetailsForm.get('pr_rstSts_purpse').value,
        },
        "education": this.proposerDetailsForm.get('pr_education').value,
        "yrInService": "",
        "prmntAddress": {
          "pincode": this.proposerDetailsForm.get('pr_currnt_pincode').value,
          "landmark": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_currnt_landmark').value).trim(),
          "state": this.proposerDetailsForm.get('pr_current_state').value,
          "line1": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_currnt_line1').value).trim(),
          "line3": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_currnt_line3').value).trim(),
          "city": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_currnt_city').value).trim(),
          "country": this.proposerDetailsForm.get('pr_current_country').value,
          "line2": this.uppercasePipe.transform(this.proposerDetailsForm.get('pr_currnt_line2').value).trim(),
        },
        "lifeStageDetails": {
          "calculator": "",
          "goals": "",
          "lifeStage": "",
          "investmentPreferance": "",
          "subGoals": "",
        },
        "occ": this.proposerDetailsForm.get('pr_occ').value,
        "occDesc": (this.proposerDetailsForm.get('pr_occDesc').value).trim(),
        "myProf": MyProfessionValue,
        "indsTypeQuestion": industypequestnvalue,
        "indsType": this.proposerDetailsForm.get('pr_indsType').value,
        "indsTypeDesc": "",
        "nameOfOrg": NameOfOrganistn,
        "nameOfOrgDesc": NameOfOrganistndecp ? NameOfOrganistndecp.trim() : "",
        "objective": this.proposerDetailsForm.get('pr_objective').value,
        "objectiveOthers": this.proposerDetailsForm.get('pr_objective_others').value,
        "annIncme": this.proposerDetailsForm.get('pr_annlncme').value,
        "panNo": "",
        "aadharCardNo": "",
        "photoSubmitted": "",
        "nationality": this.proposerDetailsForm.get('pr_nationality').value,
        // "email": this.uppercasePipe.transform(this.quoteFormResObj?.email),
        // "email": (this.quoteFormResObj?.qt_email).toUpperCase(),
        "email": (this.proposerDetailsForm.get('pr_email').value).toUpperCase(),
        "pltclyExpsd": this.proposerDetailsForm.get('pr_pltclyExpsd').value ? "Yes" : "No",
        "currentlyInvestigated": this.proposerDetailsForm.get('pr_currentlyInvestigated').value ? "Yes" : "No",
        "investigationDtls": this.proposerDetailsForm.get('pr_investigationDtls').value,
        "landLnNo": "",
        "stdNo": "",
        "rural_lan": "",
        "rural_policyno": "",
        "rural_policyamt": "",
        "rstSts": this.proposerDetailsForm.get('pr_rstSts').value,
      },
      "sourceOfFund": this.proposerDetailsForm.get('pr_sourceOfFund').value,
      "sourceOfFundDesc": this.proposerDetailsForm.get('pr_sourceOfFundDesc').value,
      "insuranceInfos": this.proposerDetailsForm.get('insuranceArray').value,
    }

    console.log('dataaaaa', this.proposal_data);
    if ((this.proposerDetailsForm.get("pr_education").value === "678" ||
      this.proposerDetailsForm.get("pr_education").value === "679" ||
      this.proposerDetailsForm.get("pr_education").value === "675")
      && this.proposerDetailsForm.get("pr_occ").value === "SPVT"
      && this.proposerDetailsForm.get('pr_annlncme').value <= 499999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 5Lak');
    }
    else if (this.proposerDetailsForm.get("pr_education").value === "676"
      && this.proposerDetailsForm.get("pr_occ").value === "SPVT"
      && this.proposerDetailsForm.get("pr_annlncme").value <= 249999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 2.5Lak');
    }
    else if (this.proposerDetailsForm.get("pr_education").value === "680"
      && this.proposerDetailsForm.get("pr_occ").value === "SPVT"
      && this.proposerDetailsForm.get("pr_annlncme").value <= 249999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 2.5Lak');
    }
    else if (this.proposerDetailsForm.get("pr_education").value === "678"
      && (this.proposerDetailsForm.get("pr_occ").value === "BSEM" ||
        this.proposerDetailsForm.get("pr_occ").value === "SECA" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEDO" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEBU" ||
        this.proposerDetailsForm.get("pr_occ").value === "SECO" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEOT" ||
        this.proposerDetailsForm.get("pr_occ").value === "SELA")
      && this.proposerDetailsForm.get('pr_annlncme').value <= 999999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 10Lak');
    }
    else if ((this.proposerDetailsForm.get("pr_education").value === "679" || this.proposerDetailsForm.get("pr_education").value === "675")
      && (this.proposerDetailsForm.get("pr_occ").value === "BSEM" ||
        this.proposerDetailsForm.get("pr_occ").value === "SECA" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEDO" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEBU" ||
        this.proposerDetailsForm.get("pr_occ").value === "SECO" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEOT" ||
        this.proposerDetailsForm.get("pr_occ").value === "SELA")
      && this.proposerDetailsForm.get('pr_annlncme').value <= 599999) {
      this.salarycondtn = true;
      this.toast.showToast(' Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 6Lak');
    }
    else if ((this.proposerDetailsForm.get("pr_education").value === "680" || this.proposerDetailsForm.get("pr_education").value === "676")
      && (this.proposerDetailsForm.get("pr_occ").value === "BSEM" ||
        this.proposerDetailsForm.get("pr_occ").value === "SECA" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEDO" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEBU" ||
        this.proposerDetailsForm.get("pr_occ").value === "SECO" ||
        this.proposerDetailsForm.get("pr_occ").value === "SEOT" ||
        this.proposerDetailsForm.get("pr_occ").value === "SELA")
      && this.proposerDetailsForm.get('pr_annlncme').value <= 41999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 4.2Lak');
    }
    else if ((this.proposerDetailsForm.get("pr_education").value === "677" ||
      this.proposerDetailsForm.get("pr_education").value === "675" ||
      this.proposerDetailsForm.get("pr_education").value === "679" ||
      this.proposerDetailsForm.get("pr_education").value === "678") &&
      this.proposerDetailsForm.get("pr_occ").value === "HSWF") {
      this.salarycondtn = true;
      this.toast.showToast('Graduation is compulsory for all housewife applicants.');
    }
    else if ((this.proposerDetailsForm.get("pr_education").value === "677" ||
      this.proposerDetailsForm.get("pr_education").value === "675" ||
      this.proposerDetailsForm.get("pr_education").value === "679" ||
      this.proposerDetailsForm.get("pr_education").value === "678") &&
      this.proposerDetailsForm.get("pr_occ").value === "AGRI") {
      this.salarycondtn = true;
      this.toast.showToast('Graduation is compulsory for all agriculturist applicants.');
    }

    else if (this.proposerDetailsForm.get("pr_education").value === "680" &&
      this.proposerDetailsForm.get("pr_occ").value === "HSWF" &&
      this.proposerDetailsForm.get("pr_annlncme").value <= 99) {
      this.salarycondtn = true;
      this.toast.showToast('Minimum Annual income should be 100rs');
    }
    else {
      this.salarycondtn = false;
      this.proposalnextcallsection();
    }

  }

  proposalnextcallsection() {
    console.log('im caleddddd heaaaaa');
    if (this.proposerDetailsForm.get('pr_gender').value === 'Male' && this.proposerDetailsForm.get('pr_mrtlSts').value === '696') {
      this.showmwpaquestion = true;
      this.hidebackbtn = false;
    }
    else {
      this.showmwpaquestion = false;
      this.hidebackbtn = false;
      this.MwpaDetailsForm.get('lf_mwpaOpted').setValue(false);
      this.NomineandINSshowField();
    }
    if (this.dependflagResponse.dependentFlag === "Y") {
      this.showProposerForm1 = false;
      this.showNomineeandIns = false;
      this.showLifeassuredForm = true;
      this.hidebackbtn = false;
      this.proposerFilled = "section-btn active-section-btn";
      this.lifeAssuredFilled = "section-btn";
      this.healthDetailsFilled = "section-btn";
      this.uploadDocumentsFilled = "section-btn";
    }
    else {
      this.showProposerForm1 = false;
      this.showNomineeandIns = true;
      this.showLifeassuredForm = false;
      this.hidebackbtn = false;
      this.proposerFilled = "section-btn active-section-btn";
      this.healthDetailsFilled = "section-btn";
      this.uploadDocumentsFilled = "section-btn";
    }

    let data = {
      dependflagResponse: this.dependflagResponse,
      proposerDetails: this.proposerDetailsForm.value
    }
    this.saveIncompleteAppData(data);
    this.strg.setStoreData("incp", true);
  }

  submitNomineeandINSForm() {
    this.checkProgress();
    this.nomineandinsdata = {
      // "beneficiaryDtls": [
      //   {
      //     "frstNm": this.MwpaDetailsForm.get("lf_br_frstNm").value,
      //     "lstNm": this.MwpaDetailsForm.get("lf_br_lstNm").value,
      //     "relationship": this.MwpaDetailsForm.get("lf_br_relationWithLa").value,
      //     "dob": this._datePipe.transform(this.MwpaDetailsForm.get("lf_br_dob").value, 'MM/dd/yyy') ? this._datePipe.transform(this.MwpaDetailsForm.get("lf_br_dob").value, 'MM/dd/yyy') : "",
      //     "shareOfBenefit": this.MwpaDetailsForm.get("lf_br_share").value,
      //     "isMinor": "",
      //   }
      // ],
      "beneficiaryDtls": this.MwpaDetailsForm.get('beneficiaryArray').value,
      "nomineeInfos": {
        "apnteDtls": {
          "frstNm": this.uppercasePipe.transform(this.MwpaDetailsForm.get("lf_ap_frstNm").value).trim(),
          "relationship": this.MwpaDetailsForm.get("lf_ap_relationWithLa").value,
          "gender": this.MwpaDetailsForm.get("lf_ap_gender").value,
          "dob": this._datePipe.transform(this.MwpaDetailsForm.get("lf_ap_dob").value, 'MM/dd/yyyy') ? this._datePipe.transform(this.MwpaDetailsForm.get("lf_ap_dob").value, 'MM/dd/yyyy') : "",
          "lstNm": (this.MwpaDetailsForm.get("lf_ap_lstNm").value).trim(),
        },
        "frstNm": this.uppercasePipe.transform(this.MwpaDetailsForm.get("lf_nm_frstNm").value).trim(),
        "relationship": this.MwpaDetailsForm.get("lf_nm_relationWithLa").value,
        "gender": this.MwpaDetailsForm.get("lf_nm_gender").value,
        "dob": this._datePipe.transform(this.MwpaDetailsForm.get("lf_nm_dob").value, 'dd-MMM-yyyy') ? this._datePipe.transform(this.MwpaDetailsForm.get("lf_nm_dob").value, 'dd-MMM-yyyy') : "",
        "lstNm": this.titlecasePipe.transform(this.MwpaDetailsForm.get("lf_nm_lstNm").value).trim(),
      },
      "trusteeDtls": [
        {
          "name": this.titlecasePipe.transform(this.MwpaDetailsForm.get('lf_tr_frstNm').value).trim(),
          "dob": this._datePipe.transform(this.MwpaDetailsForm.get('lf_tr_dob').value, 'dd-MMM-yyyy') ? this._datePipe.transform(this.MwpaDetailsForm.get('lf_tr_dob').value, 'dd-MMM-yyyy') : "",
          "trusteeType": this.MwpaDetailsForm.get('lf_tr_relationWithLa').value,
          "address": (this.MwpaDetailsForm.get('lf_tr_address').value).trim(),
          "city": (this.MwpaDetailsForm.get('lf_tr_city').value).trim(),
          "pincode": this.MwpaDetailsForm.get('lf_tr_pincode').value,
          "state": this.MwpaDetailsForm.get('lf_tr_state').value,
          "panNo": this.uppercasePipe.transform(this.MwpaDetailsForm.get('lf_tr_panNo').value),
          "mobileNo": this.MwpaDetailsForm.get('lf_tr_mobNo').value,
          "email": this.MwpaDetailsForm.get('lf_tr_email').value,
          "salutation": this.MwpaDetailsForm.get('lf_tr_salutn').value
        }
      ],

      "mwpaOpted": this.MwpaDetailsForm.get('lf_mwpaOpted').value ? "Yes" : "No",
      "mwpaBenefit": ""//not in ui
    }
    if (this.MwpaDetailsForm.get("lf_nm_relationWithLa").value === "Brother in law" &&
      this.proposerDetailsForm.get('pr_mrtlSts').value === "697") {
      this.showLifeassuredForm = false;
      this.showHealthDeatilsForm = false;
      this.showNomineeandIns = true;
      this.showProposerForm1 = false;
      this.hidebackbtn = true;
      this.toast.showToast('The selected individual is not eligible to be your nominee');
      console.log('fffffffff')
    }
    else {
      this.showNomineeandIns = false;
      this.hidebackbtn = false;
      this.showLifeassuredForm = false;
      this.showHealthDeatilsForm = true;
      this.showProposerForm1 = false;
      this.proposerFilled = "section-btn section-done-btn";
      this.healthDetailsFilled = "section-btn active-section-btn";
      this.uploadDocumentsFilled = "section-btn";
      this.EIADetailsfilled = "section-btn";
      console.log('bbbbbbbb')
    }
    console.log('nomineeee', this.nomineandinsdata);
    let data = {
      dependflagResponse: this.dependflagResponse,
      proposerDetails: this.proposerDetailsForm.value,
      nomineeDetails: this.MwpaDetailsForm.value
    }
    this.saveIncompleteAppData(data);
  }
  //
  submitLifeDetailsForm() {
    this.checkProgress();
    let lf_orgntypeselection;
    let lf_organistntypedescptn;
    let lf_NameOfOrganistn;
    let lf_NameOfOrganistndecp;
    let MyProfessionValue_lf;
    let lf_nriUSValue;

    if (
      // this.LifeDetailsForm.get('lf_occ').value === "SEDO" ||
      // this.LifeDetailsForm.get('lf_occ').value === "SEAR" ||
      this.LifeDetailsForm.get('lf_occ').value === "SEBU" ||
      // this.LifeDetailsForm.get('lf_occ').value === "SELA" ||
      this.LifeDetailsForm.get('lf_occ').value === "SEOT") {
      lf_NameOfOrganistn = "Others"
      lf_NameOfOrganistndecp = "Others"
      lf_orgntypeselection = "NOT ANSWERED";
      lf_organistntypedescptn = "Others"
    }
    else {
      lf_NameOfOrganistn = this.LifeDetailsForm.get('lf_nameOfOrg').value.organizationName;
      lf_NameOfOrganistndecp = this.LifeDetailsForm.get('lf_nameOfOrgdecstn').value;
      lf_orgntypeselection = this.LifeDetailsForm.get('lf_org_selfemployed').value;
      lf_organistntypedescptn = this.LifeDetailsForm.get('lf_orgTypeDesc').value
    }
    if (this.LifeDetailsForm.get('lf_occ').value === "BSEM") {
      lf_orgntypeselection = this.LifeDetailsForm.get('lf_org_selfemployed').value;
      lf_NameOfOrganistn = "Others"
      lf_NameOfOrganistndecp = this.LifeDetailsForm.get('lf_nameOfOrgdecstn').value;
      lf_organistntypedescptn = this.LifeDetailsForm.get('lf_orgTypeDesc').value
    }
    if (this.LifeDetailsForm.get('lf_occ').value === "SPVT" ||
      this.LifeDetailsForm.get('lf_occ').value === "SPRO") {
      lf_orgntypeselection = this.LifeDetailsForm.get('lf_orgType').value;
    }

    if (this.LifeDetailsForm.get('lf_occ').value === "SELA") {
      MyProfessionValue_lf = "Lawyer"
    } else if (this.LifeDetailsForm.get('lf_occ').value === "SECA") {
      MyProfessionValue_lf = "CA"
    } else if (this.LifeDetailsForm.get('lf_occ').value === "SEDO") {
      MyProfessionValue_lf = "Doctor"
    } else if (this.LifeDetailsForm.get('lf_occ').value === "SEAR") {
      MyProfessionValue_lf = "Other"
    } else {
      MyProfessionValue_lf = this.LifeDetailsForm.get('lf_myprof').value
    }

    if (this.LifeDetailsForm.get('lf_rstSts_nri').value === true) {
      lf_nriUSValue = "Yes"
    } else if (this.LifeDetailsForm.get('lf_rstSts_nri').value === false) {
      lf_nriUSValue = "No"
    } else {
      lf_nriUSValue = "";
    }
    this.lifeassured_data = {
      "lifeAssrdInfos": {
        "frstNm": this.titlecasePipe.transform(this.LifeDetailsForm.get('lf_frstNm').value),
        "lstNm": this.titlecasePipe.transform(this.LifeDetailsForm.get('lf_lstNm').value),
        "dob": this._datePipe.transform(this.LifeDetailsForm.get('lf_dob').value, 'dd-MMMM-yyy') ? this._datePipe.transform(this.LifeDetailsForm.get('lf_dob').value, 'dd-MMMM-yyy') : "",
        "mrtlSts": this.LifeDetailsForm.get('lf_mrtlSts').value,
        "gender": this.LifeDetailsForm.get('lf_gender').value,
        "pinCode": this.LifeDetailsForm.get('lf_pincode').value,
        "relationship": "",
        "orgType": this.uppercasePipe.transform(lf_orgntypeselection),
        "orgTypeDesc": this.LifeDetailsForm.get('lf_orgTypeDesc').value,
        "mobNo": this.LifeDetailsForm.get('lf_mobNo').value,
        "landLnNo": "",
        "stdNo": "",
        "nationality": this.LifeDetailsForm.get('lf_nationality').value,
        "aadharCardNo": "",
        "education": this.LifeDetailsForm.get('lf_education').value,
        "kycDoc": "",
        "nri": {
          "passportNo": this.LifeDetailsForm.get('lf_rstSts_passport').value,
          "dateOfArrivingIndia": this._datePipe.transform(this.LifeDetailsForm.get('lf_rstSts_DOA').value, 'MM/dd/yyyy') ? this._datePipe.transform(this.LifeDetailsForm.get('lf_rstSts_DOA').value, 'MM/dd/yyyy') : "",
          "dateOfLeavingIndia": this._datePipe.transform(this.LifeDetailsForm.get('lf_rstSts_DOL').value, 'MM/dd/yyyy') ? this._datePipe.transform(this.LifeDetailsForm.get('lf_rstSts_DOL').value, 'MM/dd/yyyy') : "",
          "durationOfStayInYear": this.LifeDetailsForm.get('lf_rstSts_DOS').value,
          "durationOfStayInMonth": this.LifeDetailsForm.get('lf_rstSts_DOSM').value,
          "nameOfEmployer": this.LifeDetailsForm.get('lf_rstSts_emp').value,
          "travelDetails": this.LifeDetailsForm.get('lf_rstSts_trvl_desc').value,
          "bankType": this.LifeDetailsForm.get('lf_rstSts_baccount').value,
          "countryOfResidence": this.LifeDetailsForm.get('lf_rstSts_nri_country').value,
          "nriTINIssuingCountry": this.LifeDetailsForm.get('lf_rstSts_tin1_contry').value,
          "tinNum": this.LifeDetailsForm.get('lf_rstSts_tin1_pan1').value,
          "tinNum2": this.LifeDetailsForm.get('lf_rstSts_tin2_pan2').value,
          "tinNum3": "",
          "nriBirthCountry": "",
          "placeOfBirthNRI": "",
          "countryOfResidence2": this.LifeDetailsForm.get('lf_rstSts_tin2_contry').value,
          "countryOfResidence3": "",
          "nriOtherResCountry": "",
          "countryOfNationality": this.LifeDetailsForm.get('lf_rstSts_nri_nationlity').value,
          "nriTaxResidentUS": lf_nriUSValue,
          "purposeOfStay": this.LifeDetailsForm.get('lf_rstSts_purpse').value,
        },
        "desig": "",
        "occ": this.LifeDetailsForm.get('lf_occ').value,
        "occDesc": this.LifeDetailsForm.get('lf_occDesc').value,
        "myProf": MyProfessionValue_lf,
        "nameOfOrg": lf_NameOfOrganistn,
        "nameOfOrgDesc": lf_NameOfOrganistndecp ? lf_NameOfOrganistndecp : "",
        "rstSts": this.LifeDetailsForm.get('lf_rstSts').value,
        "annIncme": this.LifeDetailsForm.get('lf_annlncme').value,
      },
    }
    if ((this.LifeDetailsForm.get("lf_education").value === "678" ||
      this.LifeDetailsForm.get("lf_education").value === "679" ||
      this.LifeDetailsForm.get("lf_education").value === "675")
      && this.LifeDetailsForm.get("lf_occ").value === "SPVT"
      && this.LifeDetailsForm.get('lf_annlncme').value <= 499999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 5Lak');
    }
    else if (this.LifeDetailsForm.get("lf_education").value === "676"
      && this.LifeDetailsForm.get("lf_occ").value === "SPVT"
      && this.LifeDetailsForm.get("lf_annlncme").value <= 249999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 2.5Lak');
    }
    else if (this.LifeDetailsForm.get("lf_education").value === "680"
      && this.LifeDetailsForm.get("lf_occ").value === "SPVT"
      && this.LifeDetailsForm.get("lf_annlncme").value <= 249999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 2.5Lak');
    }
    else if (this.LifeDetailsForm.get("lf_education").value === "678"
      && (this.LifeDetailsForm.get("lf_occ").value === "BSEM" ||
        this.LifeDetailsForm.get("lf_occ").value === "SECA" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEDO" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEBU" ||
        this.LifeDetailsForm.get("lf_occ").value === "SECO" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEOT" ||
        this.LifeDetailsForm.get("lf_occ").value === "SELA")
      && this.LifeDetailsForm.get('lf_annlncme').value <= 999999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 10Lak');
    }
    else if ((this.LifeDetailsForm.get("lf_education").value === "679" || this.LifeDetailsForm.get("lf_education").value === "675")
      && (this.LifeDetailsForm.get("lf_occ").value === "BSEM" ||
        this.LifeDetailsForm.get("lf_occ").value === "SECA" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEDO" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEBU" ||
        this.LifeDetailsForm.get("lf_occ").value === "SECO" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEOT" ||
        this.LifeDetailsForm.get("lf_occ").value === "SELA")
      && this.LifeDetailsForm.get('lf_annlncme').value <= 599999) {
      this.salarycondtn = true;
      this.toast.showToast(' Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 6Lak');
    }
    else if ((this.LifeDetailsForm.get("lf_education").value === "680" || this.LifeDetailsForm.get("lf_education").value === "676")
      && (this.LifeDetailsForm.get("lf_occ").value === "BSEM" ||
        this.LifeDetailsForm.get("lf_occ").value === "SECA" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEDO" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEBU" ||
        this.LifeDetailsForm.get("lf_occ").value === "SECO" ||
        this.LifeDetailsForm.get("lf_occ").value === "SEOT" ||
        this.LifeDetailsForm.get("lf_occ").value === "SELA")
      && this.LifeDetailsForm.get('lf_annlncme').value <= 41999) {
      this.salarycondtn = true;
      this.toast.showToast('Your Annual Income is not eligible to buy life insurance cover. The minimum annual income should be 4.2Lak');
    }
    else if ((this.LifeDetailsForm.get("lf_education").value === "677" ||
      this.LifeDetailsForm.get("lf_education").value === "675" ||
      this.LifeDetailsForm.get("lf_education").value === "679" ||
      this.LifeDetailsForm.get("lf_education").value === "678") &&
      this.LifeDetailsForm.get("lf_occ").value === "HSWF") {
      this.salarycondtn = true;
      this.toast.showToast('Graduation is compulsory for all housewife applicants.');
    }
    else if ((this.LifeDetailsForm.get("lf_education").value === "677" ||
      this.LifeDetailsForm.get("lf_education").value === "675" ||
      this.LifeDetailsForm.get("lf_education").value === "679" ||
      this.LifeDetailsForm.get("lf_education").value === "678") &&
      this.LifeDetailsForm.get("lf_occ").value === "AGRI") {
      this.salarycondtn = true;
      this.toast.showToast('Graduation is compulsory for all agriculturist applicants.');
    }
    else if (this.LifeDetailsForm.get("lf_education").value === "680" &&
      this.LifeDetailsForm.get("lf_occ").value === "HSWF" &&
      this.LifeDetailsForm.get("lf_annlncme").value <= 99) {
      this.salarycondtn = true;
      this.toast.showToast('Minimum Annual income should be 100rs');
    }
    else {
      this.salarycondtn = false;
      this.showHealthDeatilsForm = true;
      this.showLifeassuredForm = false;
      this.showpaymentDocumentForm = false;
      this.hidebackbtn = false;
      console.log("life assured deatils form", this.lifeassured_data);
      this.proposerFilled = "section-btn section-done-btn";
      this.lifeAssuredFilled = "section-btn section-done-btn";
      this.healthDetailsFilled = "section-btn active-section-btn";
      this.uploadDocumentsFilled = "section-btn";
      this.EIADetailsfilled = "section-btn";

      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        lifeAssuredDetails: this.LifeDetailsForm.value
      }
      this.saveIncompleteAppData(data);
    }
  }

  submitHealthDetailsForm() {
    this.checkProgress();
    // let cms = this.HealthDetailsForm.get('hl_height_cms').value;
    // let foot = (cms / 30.48).toFixed(1);
    // let feet = foot.split(".")[0];
    // let inches = foot.split(".")[1];
    // console.log(`${feet} feet ${inches} inches`);
    let actualfeet = Number(this.HealthDetailsForm.get('hl_height_feet').value);
    let onefeet = 12;
    let feet = Number(this.HealthDetailsForm.get('hl_height_feet').value) * onefeet;
    console.log(feet, 'fettttttttt')
    let inches = Number(this.HealthDetailsForm.get('hl_height_inch').value);
    console.log(inches, 'inchsssssssss')
    let totalinc = Number(feet) + Number(inches);
    console.log(totalinc, 'totttallll')
    let cms = totalinc * 2.54

    this.health_data = {
      "healthDetails": [
        {
          "answer1": String(actualfeet),
          "code": "HQ01",
          "answer3": "",
          "answer2": String(actualfeet + " feet " + inches + " inches"),
          "answer4": ""
        },
        {
          "answer1": String(inches),
          "code": "HQ02",
          "answer3": "",
          // "answer2": String(this.HealthDetailsForm.get('hl_height_cms').value),
          "answer2": String(cms),
          "answer4": ""
        },
        {
          "answer1": String(this.HealthDetailsForm.get('hl_weight').value),
          "code": "HQ03",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_tabacoo').value,
          "code": "HQ05",
          "answer3": this.HealthDetailsForm.get('hl_quant_day').value,
          "answer2": this.HealthDetailsForm.get('hl_consumption_period').value,
          "answer4": this.HealthDetailsForm.get('hl_tabaco_years').value
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_alcohol').value,
          "code": "HQ06",
          "answer3": this.HealthDetailsForm.get('hl_alch_day').value,
          "answer2": this.HealthDetailsForm.get('hl_alch_period').value,
          "answer4": this.HealthDetailsForm.get('hl_alch_years').value
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_narcotics').value,
          "code": "HQ07",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_chemical_exposure').value,
          "code": "HQ09",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_army_emply').value,
          "code": "HQ125",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_lost_wgts').value,
          "code": "HQ144",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_fmly_illnes').value,
          "code": "HQ165",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_surgery').value,
          "code": "HQ166",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer15": this.HealthDetailsForm.get('hl_answer15').value ? "No" : "Yes",
          "answer1": this.HealthDetailsForm.get('hl_answer1').value ? "Yes" : "No",
          "code": "HQ167",
          "answer3": this.HealthDetailsForm.get('hl_answer3').value ? "Yes" : "No",
          "answer2": this.HealthDetailsForm.get('hl_answer2').value ? "Yes" : "No",
          "answer4": this.HealthDetailsForm.get('hl_answer4').value ? "Yes" : "No",
          "answer5": this.HealthDetailsForm.get('hl_answer5').value ? "Yes" : "No",
          "answer6": this.HealthDetailsForm.get('hl_answer6').value ? "Yes" : "No",
          "answer7": this.HealthDetailsForm.get('hl_answer7').value ? "Yes" : "No",
          "answer8": this.HealthDetailsForm.get('hl_answer8').value ? "Yes" : "No",
          "answer9": this.HealthDetailsForm.get('hl_answer9').value ? "Yes" : "No",
          "answer10": this.HealthDetailsForm.get('hl_answer10').value ? "Yes" : "No",
          "answer11": this.HealthDetailsForm.get('hl_answer11').value ? "Yes" : "No",
          "answer12": this.HealthDetailsForm.get('hl_answer12').value ? "Yes" : "No",
          "answer13": this.HealthDetailsForm.get('hl_answer13').value ? "Yes" : "No",
          "answer14": this.HealthDetailsForm.get('hl_answer14').value ? "Yes" : "No",
        },
        {
          "answer15": "No",
          "answer1": this.HealthDetailsForm.get('hl_declartion_form').value ? this.HealthDetailsForm.get('hl_declartion_form').value : "No",
          "code": "HQ188",
          "answer3": this.HealthDetailsForm.get('hl_medical_diagnosis').value,
          "answer2": this.HealthDetailsForm.get('hl_medi_condn').value,
          "answer4": this.HealthDetailsForm.get('hl_medical_treatmt').value,
          "answer5": this.HealthDetailsForm.get('hl_med_currntstg').value,
          "answer6": this.HealthDetailsForm.get('hl_medical_detls').value,
          "answer7": this.HealthDetailsForm.get('hl_medical_testundgne').value,
          "answer8": this.HealthDetailsForm.get('hl_medical_othrdtls').value,
          "answer9": "No",
          "answer10": "No",
          "answer11": "No",
          "answer12": "No",
          "answer13": "No",
          "answer14": "No"
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_med_handicap').value,
          "code": "HQ21",
          "answer3": "",
          "answer2": this.remarkarry.join(""),
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_med_injury').value,
          "code": "HQ24",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_med_suffering').value,
          "code": "HQ168",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        {
          "answer1": this.HealthDetailsForm.get('hl_pregant').value ? this.HealthDetailsForm.get('hl_pregant').value : "",
          "code": "HQ61",
          "answer3": "",
          "answer2": "",
          "answer4": ""
        },
        // {
        //   "code": "CHQ1",
        //   // "lifeType": this.HealthDetailsForm.get('hl_covid_test').value,
        //   // "answer1": "No"
        //   "answer1": this.HealthDetailsForm.get('hl_covid_test').value
        // },
        // {
        //   "code": "CHQ2",
        //   // "lifeType": this.HealthDetailsForm.get('hl_covid_selfisolated').value,
        //   // "answer1": "No"
        //   "answer1": this.HealthDetailsForm.get('hl_covid_selfisolated').value
        // },
        // {
        //   "code": "CHQ3",
        //   // "lifeType": this.HealthDetailsForm.get('hl_covid_advice').value,
        //   // "answer1": "No"
        //   "answer1": this.HealthDetailsForm.get('hl_covid_advice').value
        // },
        // {
        //   "code": "CHQ4",
        //   // "lifeType": this.HealthDetailsForm.get('hl_covid_cough').value,
        //   // "answer1": "No"
        //   "answer1": this.HealthDetailsForm.get('hl_covid_cough').value
        // },
        // {
        //   "code": "CHQ5",
        //   // "lifeType": this.HealthDetailsForm.get('hl_covid_office').value,
        //   // "answer1": "No"
        //   "answer1": this.HealthDetailsForm.get('hl_covid_office').value
        // },
        {
          "code": "CHQ14",
          "answer1": this.HealthDetailsForm.get('hl_covid_everTested').value
        },
        {
          "code": "CHQ19",
          "answer1": this.HealthDetailsForm.get('hl_covid_famSelfisolated').value
        },
        {
          "code": "CHQ20",
          "answer1": this.HealthDetailsForm.get('hl_covid_coughAdvice').value
        },
        {
          "code": "CHQ21",
          "answer1": this.HealthDetailsForm.get('hl_covid_coronaWarrior').value
        },
        // {
        //   "code": "CHQ22",
        //   "answer1": this.HealthDetailsForm.get('hl_covid_travel').value
        // },
        // {
        //   "code": "CHQ26",
        //   "answer1": this.HealthDetailsForm.get('hl_covid_vaccine').value
        // },
        {
          "code": "CHQ30",
          "answer1": this.HealthDetailsForm.get('hl_covid_isVaccinated').value
        },
        {
          // "code": "CHQ27",
          "code": "CHQ36",
          "answer1": this.HealthDetailsForm.get('hl_covid_vaccineSideEffect').value
        },
        {
          "code": "CHQ38",
          "answer1": this.HealthDetailsForm.get('hl_covid_outsideInd').value
        },
        {
          "code": "CHQ43",
          "answer1": this.HealthDetailsForm.get('hl_covid_travel14').value
        },
        {
          "code": "CHQ56",
          "answer1": this.HealthDetailsForm.get('hl_covid_travel3M').value
        },
      ]
    }

    if (this.HealthDetailsForm.get("hl_covid_isVaccinated").value === "Yes") {
      this.health_data.healthDetails.push({
        "code": "CHQ31",
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_1stDoseDate').value, "MM/dd/yyyy")
      }, {
        "code": "CHQ32",
        "answer1": this.HealthDetailsForm.get('hl_covid_1stDoseName').value
      })
    }

    if (this.HealthDetailsForm.get("hl_covid_isVaccinated2ndDose").value === "Yes") {
      this.health_data.healthDetails.push({
        "code": "CHQ33",
        "answer1": this.HealthDetailsForm.get('hl_covid_isVaccinated2ndDose').value
      },
        {
          "code": "CHQ34",
          "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_2ndDoseDate').value, "MM/dd/yyyy")
        }, {
        "code": "CHQ35",
        "answer1": this.HealthDetailsForm.get('hl_covid_2ndDoseName').value
      })
    } else {
      this.health_data.healthDetails.push({
        "code": "CHQ33",
        "answer1": this.HealthDetailsForm.get('hl_covid_isVaccinated2ndDose').value
      })
    }

    if (this.HealthDetailsForm.get("hl_covid_outsideInd").value === "Yes") {
      this.health_data.healthDetails.push(
        {
          "code": "CHQ39",
          "answer1": this.HealthDetailsForm.get('hl_covid_outsideIndCountry').value
        }, {
        "code": "CHQ40",
        "answer1": this.HealthDetailsForm.get('hl_covid_outsideIndCity').value
      }, {
        "code": "CHQ41",
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_outsideIndDateOfTarvel').value, "MM/dd/yyyy")
      }, {
        "code": "CHQ42",
        "answer1": this.HealthDetailsForm.get('hl_covid_outsideIndIndentedMonth').value
      })
    }

    if (this.HealthDetailsForm.get("hl_covid_travel14").value === "Yes") {
      this.health_data.healthDetails.push(
        {
          "code": "CHQ44",
          "answer1": this.HealthDetailsForm.get('hl_covid_travel14Country').value
        }, {
        "code": "CHQ45",
        "answer1": this.HealthDetailsForm.get('hl_covid_travel14City').value
      }, {
        "code": "CHQ46",
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_travel14DateArrived').value, "MM/dd/yyyy")
      }, {
        "code": "CHQ47",
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_travel14DateDeptd').value, "MM/dd/yyyy")
      })
    }

    if (this.HealthDetailsForm.get("hl_covid_travel3M").value === "Yes") {
      this.health_data.healthDetails.push(
        {
          "code": "CHQ39",
          "answer1": this.HealthDetailsForm.get('hl_covid_travel3MCountry').value
        }, {
        "code": "CHQ40",
        "answer1": this.HealthDetailsForm.get('hl_covid_travel3MCity').value
      }, {
        "code": "CHQ41",
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_travel3MDateOfTarvel').value, "MM/dd/yyyy")
      }, {
        "code": "CHQ42",
        "answer1": this.HealthDetailsForm.get('hl_covid_travel3MIndentedMonth').value
      })
    }

    if (this.HealthDetailsForm.get("hl_covid_everTested").value === "Yes") {
      this.health_data.healthDetails.push({
        "code": "CHQ15",
        "answer1": this.HealthDetailsForm.get('hl_covid_fullyRecovered').value
      },)
    }

    if (this.HealthDetailsForm.get("hl_covid_fullyRecovered").value === "Yes") {
      this.health_data.healthDetails.push({
        "code": "CHQ16",
        // "answer1": this.HealthDetailsForm.get('hl_covid_dateOfDiagnosis').value
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_dateOfDiagnosis').value, 'MM/dd/yyyy')
      }, {
        "code": "CHQ17",
        // "answer1": this.HealthDetailsForm.get('hl_covid_dateOfRecovery').value
        "answer1": this._datePipe.transform(this.HealthDetailsForm.get('hl_covid_dateOfRecovery').value, 'MM/dd/yyyy')
      }, {
        "code": "CHQ18",
        "answer1": this.HealthDetailsForm.get('hl_covid_hospital').value
      },);
    }

    if (this.HealthDetailsForm.get("hl_covid_travel").value === "Yes") {
      this.health_data.healthDetails.push({
        "code": "CHQ23",
        "answer1": this.HealthDetailsForm.get('hl_covid_travelCountry').value
      }, {
        "code": "CHQ24",
        "answer1": this.HealthDetailsForm.get('hl_covid_arrivalDt').value
      }, {
        "code": "CHQ25",
        "answer1": this.HealthDetailsForm.get('hl_covid_leavingDt').value
      },);
    }

    if (this.HealthDetailsForm.get("hl_covid_vaccineSideEffect").value === "Yes") {
      this.health_data.healthDetails.push(
        //   {
        //   "code": "CHQ28",
        //   "answer1": this.HealthDetailsForm.get('hl_covid_vaccineSideEffectHospital').value
        // },
        {
          // "code": "CHQ29",
          "code": "CHQ37",
          "answer1": this.HealthDetailsForm.get('hl_covid_vaccineSideEffectDetails').value
        },);
    }

    console.log("health que obj", this.health_data);

    this.showUploadDetailsForm = true;
    this.showHealthDeatilsForm = false;
    this.showProposerForm1 = false;
    this.showpaymentDocumentForm = false;
    this.showNomineeandIns = false;
    this.hidebackbtn = false;
    console.log('form data of health', this.health_data);

    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn active-section-btn";
    this.EIADetailsfilled = "section-btn";

    if (this.showLifeassuredformbtn) {
      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        lifeAssuredDetails: this.LifeDetailsForm.value,
        healthDetails: this.HealthDetailsForm.value
      }
      this.saveIncompleteAppData(data);
    } else {
      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        healthDetails: this.HealthDetailsForm.value
      }
      this.saveIncompleteAppData(data);
    }
  }

  showOtpVerify: boolean = false;
  prPhoneNumber: string = "";
  prPhoneNumberOtp: string = "";
  showOtpInput: boolean = false;
  disablePhoneInput: boolean = true;
  disableOtpInput: boolean = false;
  otpReqCrTime: string;
  otpReqUpTime: string;
  showSegmentBtns: boolean = true;

  backFromOtpVerify() {
    this.showpaymentDocumentForm = true;
    this.showOtpVerify = false;
    this.showOtpInput = false;
    this.disableOtpInput = false;
    this.prPhoneNumberOtp = "";
    this.showSegmentBtns = true;
    this.hidebackbtn = false;
  }

  editNumberClicked() {
    this.disablePhoneInput = false;
    this.showOtpInput = false;
    this.hidebackbtn = false;
  }

  sendOtpClicked() {
    this.disablePhoneInput = true;
    this.hidebackbtn = false;
    //send otp api
    this.loader.showLoader();
    // this.apiService.sendOtp(this.prPhoneNumber, this.userObj.id).subscribe(res => { //for direct ref
    this.apiService.sendOtp(this.prPhoneNumber).subscribe(res => {
      this.loader.hideLoader();
      console.log("opt res", res);
      if (res.data.type === "success") {
        this.otpReqCrTime = res.timestamp;
        this.toast.showToast("OTP Sent Successfully");
        this.showOtpInput = true;
      }
    }, err => {
      this.loader.hideLoader();
      this.toast.showToast(err.error.message);
      console.log("otp error", err)
    })
  }

  verifyOtpClicked() {
    //verify otp api
    if (this.prPhoneNumberOtp && this.prPhoneNumber) {
      let data = {
        'mobile': this.prPhoneNumber,
        'otp': this.prPhoneNumberOtp,
        // 'userId': this.userObj.id //for direct ref
      };
      this.loader.showLoader();
      this.apiService.verifyOtpIcici(data).subscribe(res => {
        this.loader.hideLoader();
        console.log("verify otp res", res);
        if (res.data.type === "success") {
          this.otpReqUpTime = res.timestamp;
          this.disableOtpInput = true;
          this.toast.showToast("OTP Verified Successfully");
          this.apiCallFunction();
          // if(this.ecsMandatory){
          //   this.router.navigateByUrl("/ecs-checkout/1");
          // } else {
          //   this.router.navigateByUrl("/ecs-checkout/0");
          // }
        } else {
          this.loader.hideLoader();
          this.toast.showToast("Invalid OTP");
        }
      }, err => {
        this.loader.hideLoader();
        this.toast.showToast(err.error.message);
        console.log("verify otp error", err);
      })
    }
  }

  resendOtpClicked() {
    //resend otp api
    this.loader.showLoader();
    // this.apiService.resendOtp(this.prPhoneNumber, this.userObj.id).subscribe(res => { //for direct ref
    this.apiService.resendOtp(this.prPhoneNumber).subscribe(res => {
      this.loader.hideLoader();
      console.log("resend opt res", res);
      this.disableOtpInput = false;
      if (res.data.type === "success") {
        this.toast.showToast("OTP Sent Successfully");
      } else {
        this.toast.showToast(res.data.message)
      }
    }, err => {
      this.loader.hideLoader();
      if (err.message) {
        this.toast.showToast(err.message);
      } else {
        this.toast.showToast(err.error.message);
      }
      console.log("resend otp error", err)
    })
  }


  submitPaymentDocument() {
    this.checkProgress();
    this.paymentDocument_data = {
      "eiaDetails": {
        "isEIAOpted": this.paymentDocumentsForm.get('pay_ele_ins').value,
        "eiaInsuranceRepository": this.paymentDocumentsForm.get('pay_ins_repo').value,
        "preferredInsuranceRepository": "",
        "convertICICIToEIA": this.paymentDocumentsForm.get('pay_ele_convt').value,
        "EIAAccountNumber": this.paymentDocumentsForm.get('pay_eia_num').value
      }
    }
    this.product_selected = {
      "CIBenefit": String(this.upgradedQuoteResponseObj.cirsumAssured),
      "premiumPayingFrequency": this.upgradedQuoteResponseObj.modeOfPayment,
      "salesChannel": String(this.upgradedQuoteResponseObj.salesChannel),
      "policyTerm": String(this.upgradedQuoteResponseObj.term),
      "premiumPayingTerm": String(this.upgradedQuoteResponseObj.premiumPaymentTerm),
      "sumAssured": String(this.upgradedQuoteResponseObj.deathBenefit),
      "productType": this.upgradedQuoteResponseObj.productType,
      "productName": this.upgradedQuoteResponseObj.productName,
      "productId": this.upgradedQuoteResponseObj.productCode,
      "LifeCoverOption": this.upgradedQuoteResponseObj.lifeCoverOption,
      "lumpsumPercentage": String(this.upgradedQuoteResponseObj.lumpsumPercentage),
      "premiumpaymentoption": this.upgradedQuoteResponseObj.premiumPaymentOption,
      "option": this.upgradedQuoteResponseObj.deathBenefitOption,
      "tobacco": String(this.upgradedQuoteResponseObj.tobacco),
      "aDHB": this.upgradedQuoteResponseObj.adbSumAssured,
      "payoutTerm": this.payoutTerm
    }
    console.log(this.product_selected, "productselected");
    this.showpaymentDocumentForm = false;
    this.showOtpVerify = true;
    this.showSegmentBtns = false;
    this.hidebackbtn = false;
    // this.apiCallFunction()      
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn section-done-btn";
    this.EIADetailsfilled = "section-btn active-section-btn";

    if (this.showLifeassuredformbtn) {
      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        lifeAssuredDetails: this.LifeDetailsForm.value,
        healthDetails: this.HealthDetailsForm.value,
        paymentDetails: this.paymentDocumentsForm.value,
        uploadDetials: this.UploadDocumentsDetailsForm.value,
        productDetails: this.product_selected
      }
      this.saveIncompleteAppData(data);
    } else {
      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        healthDetails: this.HealthDetailsForm.value,
        paymentDetails: this.paymentDocumentsForm.value,
        uploadDetials: this.UploadDocumentsDetailsForm.value,
        productDetails: this.product_selected
      }
      this.saveIncompleteAppData(data);
    }
  }

  aadharFormatting(event) {
    // if (event.keyCode == 46 || event.keyCode == 8) {
    //   console.log("ooooo");
    //   return true
    // } else{
    //   let aadharInput = this.UploadDocumentsDetailsForm.get('up_aadharCardNo');
    //   let inputValue = aadharInput.value.split(/\s+/).join('');
    //   if(inputValue.length > 0 && inputValue.length < 12) {
    //     if (inputValue.length % 4 == 0) {
    //       let inputValWithSpace = aadharInput.value + " ";
    //       aadharInput.setValue(inputValWithSpace)
    //     }
    //   }
    // }

    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 39 || event.keyCode == 9) {
      let aadharInput = this.UploadDocumentsDetailsForm.get('up_aadharCardNo');
      let inputValue = aadharInput.value.split(/\s+/).join('');
      if (inputValue.length > 0 && inputValue.length < 12) {
        if (inputValue.length % 4 == 0) {
          let inputValWithSpace = aadharInput.value + " ";
          aadharInput.setValue(inputValWithSpace)
        }
      }
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else {
      let aadharInput = this.UploadDocumentsDetailsForm.get('up_aadharCardNo');
      let inputValue = aadharInput.value.split(/\s+/).join('');
      if (inputValue.length > 0 && inputValue.length < 12) {
        if (inputValue.length % 4 == 0) {
          let inputValWithSpace = aadharInput.value + " ";
          aadharInput.setValue(inputValWithSpace)
        }
      }
      return true;
    }

  }

  submitUploadDocument() {
    this.checkProgress();
    this.showUploadDetailsForm = false;
    this.showpaymentDocumentForm = true;
    this.hidebackbtn = false;
    this.uploaddocument_data_kyc_proposer = {
      "idPrf": this.UploadDocumentsDetailsForm.get('up_idPrf').value,
      "addPrf": this.UploadDocumentsDetailsForm.get('up_addPrf').value,
      "agePrf": this.UploadDocumentsDetailsForm.get('up_agePrf').value,
      "itPrf": this.UploadDocumentsDetailsForm.get('up_itPrf').value,
      "incomePrf": this.UploadDocumentsDetailsForm.get('up_incomePrf').value,
      "lddIdOthrDesc": "",
      "lddIdNumber": "",
      "lddIdExpiryDate": ""
    }
    this.uploaddoc_data_kyc_lifeassured = {
      "idPrf": this.UploadDocumentsDetailsForm.get('up_idPrf').value,
      "addPrf": this.UploadDocumentsDetailsForm.get('up_addPrf').value,
      "agePrf": this.UploadDocumentsDetailsForm.get('up_agePrf').value,
      "itPrf": this.UploadDocumentsDetailsForm.get('up_itPrf').value,
    }
    this.uploaddoc_pannumber = this.UploadDocumentsDetailsForm.get('up_panNo').value;
    // this.uploadoc_aharnumber = this.UploadDocumentsDetailsForm.get('up_aadharCardNo').value.split(/\s+/).join('');
    this.uploadoc_aharnumber = this.UploadDocumentsDetailsForm.get('up_aadharCardNo').value;
    this.upload_photosubmitted = this.UploadDocumentsDetailsForm.get('up_pic_sub').value ? "Yes" : "No";

    console.log(this.uploaddocument_data_kyc_proposer, "upload document-data-propser");

    if (this.dependflagResponse.dependentFlag === "Y") {
      this.proposal_data.proposerInfos.kycDoc = this.uploaddocument_data_kyc_proposer;
      this.lifeassured_data.lifeAssrdInfos.kycDoc = this.uploaddoc_data_kyc_lifeassured;
      this.proposal_data.proposerInfos.panNo = this.uploaddoc_pannumber;
      this.proposal_data.proposerInfos.aadharCardNo = this.uploadoc_aharnumber;
      this.lifeassured_data.lifeAssrdInfos.aadharCardNo = this.uploadoc_aharnumber;
      this.proposal_data.proposerInfos.photoSubmitted = this.upload_photosubmitted;
    }
    else {
      this.proposal_data.proposerInfos.kycDoc = this.uploaddocument_data_kyc_proposer;
      this.proposal_data.proposerInfos.panNo = this.uploaddoc_pannumber;
      this.proposal_data.proposerInfos.aadharCardNo = this.uploadoc_aharnumber;
      this.proposal_data.proposerInfos.photoSubmitted = this.upload_photosubmitted;
    }
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn section-done-btn";
    this.EIADetailsfilled = "section-btn active-section-btn";

    if (this.showLifeassuredformbtn) {
      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        lifeAssuredDetails: this.LifeDetailsForm.value,
        healthDetails: this.HealthDetailsForm.value,
        paymentDetails: this.paymentDocumentsForm.value,
        productDetails: this.product_selected,
        uploadDetials: this.UploadDocumentsDetailsForm.value
      }
      this.saveIncompleteAppData(data);
    } else {
      let data = {
        dependflagResponse: this.dependflagResponse,
        proposerDetails: this.proposerDetailsForm.value,
        nomineeDetails: this.MwpaDetailsForm.value,
        healthDetails: this.HealthDetailsForm.value,
        paymentDetails: this.paymentDocumentsForm.value,
        productDetails: this.product_selected,
        uploadDetials: this.UploadDocumentsDetailsForm.value
      }
      this.saveIncompleteAppData(data);
    }
  }

  propose() {
    this.showProposerForm1 = true;
    this.showHealthDeatilsForm = false;
    this.showUploadDetailsForm = false;
    this.showLifeassuredForm = false;
    this.showpaymentDocumentForm = false;
    this.showErrorDiv = false;
    this.showOtpVerify = false;
    this.hidebackbtn = false;
    this.proposerFilled = "section-btn active-section-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn section-done-btn";
    this.EIADetailsfilled = "section-btn section-done-btn";
  }
  health() {
    this.showHealthDeatilsForm = true;
    this.showProposerForm1 = false;
    this.showUploadDetailsForm = false;
    this.showLifeassuredForm = false;
    this.showpaymentDocumentForm = false;
    this.showErrorDiv = false;
    this.showOtpVerify = false;
    this.hidebackbtn = false;
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn active-section-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn section-done-btn";
    this.EIADetailsfilled = "section-btn section-done-btn";
  }
  upload() {
    this.showUploadDetailsForm = true;
    this.showProposerForm1 = false;
    this.showHealthDeatilsForm = false;
    this.showLifeassuredForm = false;
    this.showpaymentDocumentForm = false;
    this.showErrorDiv = false;
    this.showOtpVerify = false;
    this.hidebackbtn = false;
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn active-section-btn";
    this.EIADetailsfilled = "section-btn section-done-btn";
  }
  life() {
    this.showLifeassuredForm = true;
    this.showUploadDetailsForm = false;
    this.showProposerForm1 = false;
    this.showHealthDeatilsForm = false;
    this.showpaymentDocumentForm = false;
    this.showErrorDiv = false;
    this.showOtpVerify = false;
    this.hidebackbtn = false;
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn  active-section-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn section-done-btn";
    this.EIADetailsfilled = "section-btn section-done-btn";
  }

  eiadetails() {
    this.hidebackbtn = false;
    this.showUploadDetailsForm = false;
    this.showpaymentDocumentForm = true;
    this.showHealthDeatilsForm = false;
    this.showLifeassuredForm = false;
    this.showNomineeandIns = false;
    this.showSubmitAPIdiv = false;
    this.showCongratulations = false;
    this.showErrorDiv = false;
    this.proposerFilled = "section-btn section-done-btn";
    this.lifeAssuredFilled = "section-btn  section-done-btn";
    this.healthDetailsFilled = "section-btn section-done-btn";
    this.uploadDocumentsFilled = "section-btn section-done-btn";
    this.EIADetailsfilled = "section-btn  active-section-btn";
  }

  //main object call
  apiCallFunction() {

    this.proposal_data.proposerInfos.mobNo = this.prPhoneNumber;
    if (this.dependflagResponse.dependentFlag === "Y") {
      this.main_Object = {
        "appNo": "",
        // "advisorCode": "00124001",
        // "advisorCode": "01400153",
        "advisorCode": "01288830",
        // "source": "PAYTMPAYOFLPAYUPD",
        // "sourceKey": "PAYTMPAYOFLPAYUPDKEY",
        // "source": "MYWEALTHJUNCTIONE2EBOL",
        // "sourceKey": "MYWEALTHJUNCTIONE2EBOLKEY",
        "source": "MYWEALTHJUNCTIONE2EBOLNEW",
        "sourceKey": "MYWEALTHJUNCTIONE2EBOLNEWKEY",
        // "salesDataReqd": "N",
        "salesDataReqd": "Y",
        "dependentFlag": this.dependflagResponse.dependentFlag,
        // "sourceTransactionId": "01600043",
        "sourceTransactionId": "56550",
        "sourceOfFund": this.proposal_data.sourceOfFund,
        "sourceOfFundDesc": this.proposal_data.sourceOfFundDesc,
        // "buyersPinCode": "600002",
        // "sellersPinCode": "400097",
        "buyersPinCode": "110075",
        "sellersPinCode": "400049",
        "clientId": "",
        // "uidId": "35684",
        "uidId": "36713",
        // "uidId": "",
        "proposerInfos": this.proposal_data.proposerInfos,
        "healthDetails": this.health_data.healthDetails,
        "productSelection": this.product_selected,
        "lifeAssrdInfos": this.lifeassured_data.lifeAssrdInfos,
        "eiaDetails": this.paymentDocument_data.eiaDetails,
        "insuranceInfos": this.proposal_data.insuranceInfos,
        "advisorSalesDetails": {
          // "channelType": "BR",
          "channelType": "CA",
          "cusBankAccNo": "",
          // "bankName": "TTIN",
          // "bankName": "WJCA",
          "bankName": "NBNK",
          "needRiskProfile": "",
          // "csrLimCode": "5032212",
          "csrLimCode": "99999999",
          // "cafosCode": "999999999",
          // "cafosCode": "999999",
          "cafosCode": "99999999",
          // "oppId": "",
          "oppId": "50000001582567",
          // "fscCode": "01286361",
          // "fscCode": "1288373",
          "fscCode": "01338896",
          // "spCode": "",
          // "spCode": "SP0690365625",
          "spCode": "SP0077128611",
          // "bankBrnch": "IE00",
          // "bankBrnch": "ZO29",
          "bankBrnch": "PYBE",
          // "source": "0TIN",
          // "source": "WJCA",
          "source": "OTHR",
          // "lanNo": "",
          // "selectedTab": "broker_ci",
          // "subChannel": ""
          "lanNo": "12345678",
          "selectedTab": "ca_ci",
          "subChannel": "casub_ci"
        },
        "otpDetails": {
          "otpReqCreatedTime": this.otpReqCrTime,
          "otpReqUpdatedTime": this.otpReqUpTime,
          "otpReqOtpNo": this.prPhoneNumberOtp,
          "otpReqStatus": "Verified",
          "otpReqExpiryTimeInMin": "15"
        }
      }
      console.log("Withlifeassured form", this.main_Object);
    }
    else {
      this.main_Object = {
        "appNo": "",
        // "advisorCode": "00124001",
        // "advisorCode": "01400153",
        "advisorCode": "01288830",
        // "source": "PAYTMPAYOFLPAYUPD",
        // "sourceKey": "PAYTMPAYOFLPAYUPDKEY",
        // "source": "MYWEALTHJUNCTIONE2EBOL",
        // "sourceKey": "MYWEALTHJUNCTIONE2EBOLKEY",
        "source": "MYWEALTHJUNCTIONE2EBOLNEW",
        "sourceKey": "MYWEALTHJUNCTIONE2EBOLNEWKEY",
        // "salesDataReqd": "N",
        "salesDataReqd": "Y",
        "dependentFlag": this.dependflagResponse.dependentFlag,
        // "sourceTransactionId": "01600043",
        "sourceTransactionId": "56550",
        "sourceOfFund": this.proposal_data.sourceOfFund,
        "sourceOfFundDesc": this.proposal_data.sourceOfFundDesc,
        // "buyersPinCode": "600002",
        // "sellersPinCode": "400097",
        "buyersPinCode": "110075",
        "sellersPinCode": "400049",
        "clientId": "",
        // "uidId": "35684",
        "uidId": "36713",
        // "uidId": "",
        "proposerInfos": this.proposal_data.proposerInfos,
        "healthDetails": this.health_data.healthDetails,
        "productSelection": this.product_selected,
        "mwpaOpted": this.nomineandinsdata.mwpaOpted,
        "mwpaBenefit": "",
        "nomineeInfos": this.nomineandinsdata.nomineeInfos,
        "beneficiaryDtls": this.nomineandinsdata.beneficiaryDtls,
        "trusteeDtls": this.nomineandinsdata.trusteeDtls,
        "eiaDetails": this.paymentDocument_data.eiaDetails,
        "insuranceInfos": this.proposal_data.insuranceInfos,
        "advisorSalesDetails": {
          // "channelType": "BR",
          "channelType": "CA",
          "cusBankAccNo": "",
          // "bankName": "TTIN",
          // "bankName": "WJCA",
          "bankName": "NBNK",
          "needRiskProfile": "",
          // "csrLimCode": "5032212",
          "csrLimCode": "99999999",
          // "cafosCode": "999999999",
          // "cafosCode": "999999",
          "cafosCode": "99999999",
          // "oppId": "",
          "oppId": "50000001582567",
          // "fscCode": "01286361",
          // "fscCode": "1288373",
          "fscCode": "01338896",
          // "spCode": "",
          // "spCode": "SP0690365625",
          "spCode": "SP0077128611",
          // "bankBrnch": "IE00",
          // "bankBrnch": "ZO29",
          "bankBrnch": "PYBE",
          // "source": "0TIN",
          // "source": "WJCA",
          "source": "OTHR",
          // "lanNo": "",
          // "selectedTab": "broker_ci",
          // "subChannel": ""
          "lanNo": "12345678",
          "selectedTab": "ca_ci",
          "subChannel": "casub_ci"
        },
        "otpDetails": {
          "otpReqCreatedTime": this.otpReqCrTime,
          "otpReqUpdatedTime": this.otpReqUpTime,
          "otpReqOtpNo": this.prPhoneNumberOtp,
          "otpReqStatus": "Verified",
          "otpReqExpiryTimeInMin": "30"
        }
      }
      console.log("without life assured form", this.main_Object);
    }

    // if(this.ecsOpted){
    //   this.main_Object["paymentData"] = {
    //     "payBankName": this.ecsDetails.bankName,
    //     "payIfscCode": this.ecsDetails.ifscCode,
    //     "payMicrNo": "",
    //     "payAccountNo": this.ecsDetails.accountNo,
    //     "payAccountHolderName": this.ecsDetails.accountHolderName,
    //     "payCrtdBy": this.ecsDetails.accountHolderName,
    //     "payAccountType": this.ecsDetails.accountType,
    //     "ecsFlag": "Y",
    //   }
    // }

    let data = {
      "orderId": this.applicationOrderId,
      "applicationData": this.main_Object
    }
    console.log("app form req", data);
    setTimeout(() => {
      this.loader.showLoader("It may take a while. Your patience is truly appreciated.");
    }, 500);
    this.apiService.postIciciApplicationForm(data).subscribe(res => {
      this.loader.hideLoader();
      console.log("application form response", res);
      this.appResData = JSON.parse(res.data);
      this.ShowHeaderRow = false;
      this.showCongratulations = true;
      this.showpaymentDocumentForm = false;
      this.showErrorDiv = false;
      this.showOtpVerify = false;
      this.hidebackbtn = false;
    }, err => {
      this.loader.hideLoader();
      this.toast.showToast(err.error.message);
      this.ShowHeaderRow = false;
      this.showErrorDiv = true;
      this.showOtpVerify = false;
      this.showpaymentDocumentForm = false;
      this.hidebackbtn = false;
      this.errdecptn = err.error.message;
      console.log(err.error.message);
    });
  }

  redirectToIcici() {
    window.open(this.appResData.url, "_blank");
  }

  billdeskpayment() {
    console.log(this.appResData, 'response of appbigdata');
    let transactionAmount = this.upgradedQuoteResponseObj.totalFirstPremiumShow;
    if (this.monthlyFreq) {
      transactionAmount = Number(this.upgradedQuoteResponseObj.totalFirstPremiumShow) * 2;
    } else {
      transactionAmount = this.upgradedQuoteResponseObj.totalFirstPremiumShow;
    }
    let payData = {
      // "email": this.userObj.email, //for direct ref
      // "transactionAmount": this.upgradedQuoteResponseObj.totalFirstPremiumShow,
      "transactionAmount": String(transactionAmount),
      // "transactionAmount": "2",
      "igst": "0.00",
      "sgst": "0.00",
      "cgst": "0.00",
      "discountAmount": "0.00",
      "appNumber": this.appResData.appNumber,
      "couponCode": null
    }
    console.log(payData, 'data');
    this.loader.showLoader("Please Wait...");
    this.apiService.generateBilldeskData(payData).subscribe(res => {
      console.log("billdesk res", res);
      if (res) {
        this.apiService.sendRedirectRequest(res.data).subscribe(response => {
          this.loader.hideLoader();
          console.log("billdesk redirect res", response);
          window.open(response.url, '_self');
        }, err => {
          this.loader.hideLoader();
          if (err.url) {
            let url = err.url;
            window.open(url, '_self');
          } else {
            let url = err._body.target.__zone_symbol__xhrURL;
            window.open(url, '_self');
          }
          this.loader.hideLoader();
        });
      }
    });
  }

  billdeskSIPayment() {
    console.log(this.appResData, 'response of appbigdata');
    let payData = {
      // "email": this.userObj.email, //for direct ref
      "transactionAmount": this.upgradedQuoteResponseObj.totalFirstPremiumShow,
      // "transactionAmount": "2",
      "igst": "0",
      "sgst": "0",
      "cgst": "0",
      "discountAmount": "0",
      "appNumber": this.appResData.appNumber,
      "couponCode": null
    }
    console.log(payData, 'data');
    this.loader.showLoader("Please Wait...");
    this.apiService.generateBilldeskSIData(payData).subscribe(res => {
      console.log("billdesk res", res);
      if (res) {
        this.apiService.sendRedirectRequest(res.data).subscribe(response => {
          this.loader.hideLoader();
          console.log("billdesk redirect res", response);
          window.open(response.url, '_self');
        }, err => {
          this.loader.hideLoader();
          if (err.url) {
            let url = err.url;
            window.open(url, '_self');
          } else {
            let url = err._body.target.__zone_symbol__xhrURL;
            window.open(url, '_self');
          }
          this.loader.hideLoader();
        });
      }
    });
  }

  checkProgress() {
    if (this.showLifeassuredformbtn) {
      if (this.proposerDetailsForm.valid && this.LifeDetailsForm.valid
        && this.HealthDetailsForm.valid && this.UploadDocumentsDetailsForm.valid) {
        this.disableFormSegmentBtns = false;
      }
    } else {
      if (this.proposerDetailsForm.valid && this.MwpaDetailsForm.valid
        && this.HealthDetailsForm.valid && this.UploadDocumentsDetailsForm.valid) {
        this.disableFormSegmentBtns = false;
      }
    }
  }

  backtoupgrade() {
    this.router.navigate(['/quote-upgrade']);
  }

  enablebtnpayment(event) {
    if (event.detail.checked == true) {
      this.enablepayment = true;
    }
    else {
      this.enablepayment = false;
    }
  }



  onChangeSearcha(event) {
    console.log(event);
    this.variablevalue = event;
    if (this.variablevalue.length > 0) {
      this.apiService.getorganisationname(this.variablevalue).subscribe(res => {
        this.naoforganstn = res.data;
        // let data ={
        //  "id": 96,
        //  "organizationName": "Others",
        //  "createdAt": "2020-12-30T10:23:07.487+0000",
        //  "updatedAt": "2020-12-30T10:23:07.487+0000"
        // }
        // this.naoforganstn.push(data);
        console.log(this.naoforganstn);
        console.log(this.proposerDetailsForm.get('pr_nameOfOrg').value, 'yyyyy')
      }, err => {
        console.log(err);
      });
    }
    else {
      console.log(this.proposerDetailsForm.get('pr_nameOfOrg').value)
    }
  }


  async subAppAfterEcs() {
    console.log("ajkhdskahsdkjahdkjahd");
    await this.submitProposalDetailsForm();
    if (this.dependflagResponse.dependentFlag === "Y") {
      await this.submitLifeDetailsForm(); // conditional call
    }
    await this.submitNomineeandINSForm();
    await this.submitHealthDetailsForm();
    await this.submitUploadDocument();
    await this.submitPaymentDocument();

    await this.apiCallFunction();
  }

  checkForNegativePincode(inp) {
    let pincodeCtrl;
    if (inp === "permanent") {
      pincodeCtrl = this.proposerDetailsForm.get("pr_pincode");
    } else {
      pincodeCtrl = this.proposerDetailsForm.get("pr_currnt_pincode");
    }
    console.log("negative pincode", pincodeCtrl);
    if (pincodeCtrl.value.length === 6) {
      this.apiService.getIciciNegativePincode(pincodeCtrl.value).subscribe(async res => {
        if (res.data.length != 0) {
          console.log("negative");
          // alert("this product is not available for the given pincode - " + pincode);
          // this.proposerDetailsForm.get("pr_pincode").setValue(null);
          // this.proposerDetailsForm.get("pr_pincode").updateValueAndValidity();

          const alert = await this.alertCtrl.create({
            cssClass: 'my-alrt-cls',
            header: 'Sorry',
            subHeader: '',
            message: 'This product is not available for the given pincode - ' + pincodeCtrl.value,
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  pincodeCtrl.setValue(null);
                  pincodeCtrl.updateValueAndValidity();
                }
              }
            ]
          });
          await alert.present();

        } else {
          console.log("positive");
        }
      });
    }
  }

}
